/**
 * Message catalogs. `tr` is the source of truth for keys; every other locale must provide the
 * same keys (enforced by the type and by a test). Plural forms use Intl.PluralRules categories.
 */

export type PluralForms = Partial<Record<Intl.LDMLPluralRule, string>> & { other: string };
export type Entry = string | PluralForms;

export const tr = {
  'app.loading': 'Yükleniyor…',
  'nav.messages': 'Mesajlar',
  'nav.calls': 'Aramalar',
  'nav.spaces': 'Alanlar',
  'nav.discover': 'Keşfet',
  'nav.ai': 'Yapay Zekâ',
  'nav.settings': 'Ayarlar',
  'auth.login.title': 'Giriş yap',
  'auth.register.title': 'Hesap oluştur',
  'auth.identifier': 'E-posta veya kullanıcı adı',
  'auth.email': 'E-posta',
  'auth.username': 'Kullanıcı adı',
  'auth.password': 'Parola',
  'auth.passwordHint': 'En az 10 karakter',
  'auth.displayName': 'Görünen ad',
  'auth.birthDate': 'Doğum tarihi',
  'auth.birthDateHint': 'Yaşına uygun güvenlik ayarlarını belirlemek için kullanılır; profilinde gösterilmez.',
  'auth.country': 'Ülke',
  'auth.acceptTerms': 'Kullanım koşullarını ve gizlilik bildirimini okudum, kabul ediyorum.',
  'auth.submitLogin': 'Giriş yap',
  'auth.submitRegister': 'Hesap oluştur',
  'auth.noAccount': 'Hesabın yok mu?',
  'auth.haveAccount': 'Zaten hesabın var mı?',
  'auth.logout': 'Çıkış yap',
  'auth.or': 'veya',
  'auth.forgotLink': 'Parolamı unuttum',
  'auth.forgot.title': 'Parolanı sıfırla',
  'auth.forgot.body': 'Hesabının e-posta adresini yaz. Bir hesap varsa sıfırlama bağlantısı göndereceğiz.',
  'auth.forgot.submit': 'Bağlantı gönder',
  'auth.forgot.sent': 'Bu adrese kayıtlı bir hesap varsa sıfırlama bağlantısı gönderildi. Bağlantı 30 dakika geçerli.',
  'auth.reset.title': 'Yeni parola belirle',
  'auth.reset.newPassword': 'Yeni parola',
  'auth.reset.submit': 'Parolayı değiştir',
  'auth.reset.done': 'Parolan değiştirildi ve tüm cihazlardaki oturumlar kapatıldı. Yeni parolanla giriş yapabilirsin.',
  'auth.verify.title': 'E-posta doğrulama',
  'auth.verify.working': 'Doğrulanıyor…',
  'auth.verify.success': 'E-posta adresin doğrulandı.',
  'auth.verify.continue': 'Uygulamaya dön',
  'auth.passkey.login': 'Passkey ile giriş yap',
  'auth.passkey.unsupported': 'Bu tarayıcı passkey desteklemiyor.',
  'auth.passkey.cancelled': 'Passkey işlemi iptal edildi.',
  'banner.emailUnverified': 'E-posta adresini doğrula: {email}',
  'banner.resend': 'Bağlantıyı tekrar gönder',
  'banner.resent': 'Doğrulama bağlantısı gönderildi.',
  'passkeys.title': 'Passkey’ler',
  'passkeys.body': 'Parola yerine cihazının kilidiyle (parmak izi, yüz, PIN) giriş yap.',
  'passkeys.add': 'Passkey ekle',
  'passkeys.empty': 'Henüz passkey eklemedin.',
  'passkeys.created': 'Eklendi: {date}',
  'passkeys.lastUsed': 'Son kullanım: {date}',
  'passkeys.remove': 'Kaldır',
  'passkeys.added': 'Passkey eklendi.',
  'passkeys.synced': 'Senkronize',
  'mail.verify.subject': '{brand}: e-posta adresini doğrula',
  'mail.verify.body': 'Merhaba {name},\n\n{brand} hesabının e-posta adresini doğrulamak için aşağıdaki bağlantıyı kullan. Bağlantı 24 saat geçerli.',
  'mail.verify.cta': 'E-postamı doğrula',
  'mail.reset.subject': '{brand}: parola sıfırlama',
  'mail.reset.body': 'Merhaba {name},\n\nParolanı sıfırlamak için aşağıdaki bağlantıyı kullan. Bağlantı 30 dakika geçerli ve tek kullanımlık. Bu isteği sen yapmadıysan bu e-postayı yok sayabilirsin; parolan değişmez.',
  'mail.reset.cta': 'Parolamı sıfırla',
  'mail.passwordChanged.subject': '{brand}: parolan değiştirildi',
  'mail.passwordChanged.body': 'Merhaba {name},\n\n{brand} hesabının parolası az önce değiştirildi ve tüm cihazlardaki oturumlar kapatıldı. Bunu sen yapmadıysan hemen destek ekibiyle iletişime geç.',
  'mail.passwordChanged.cta': 'Giriş yap',
  'mail.test.subject': '{brand}: test e-postası',
  'mail.test.body': 'Merhaba {name},\n\nBu, {brand} yönetim panelinden gönderilen bir test e-postasıdır. Bunu okuyabiliyorsan e-posta gönderimi çalışıyor.',
  'mail.test.cta': 'Paneli aç',
  'mail.footer': 'Bu e-posta {brand} hesabınla ilgili bir işlem nedeniyle otomatik gönderildi.',
  'chat.title': 'Sohbetler',
  'chat.search': 'Sohbetlerde ara',
  'chat.new': 'Yeni sohbet',
  'chat.empty': 'Henüz sohbetin yok. Kişiler bölümünden @kullanıcıadı ile birini ekleyip sohbet başlat.',
  'chat.select': 'Bir sohbet seç',
  'chat.selectBody': 'Soldaki listeden bir sohbet seç ya da yeni bir sohbet başlat.',
  'chat.placeholder': 'Mesaj yaz',
  'chat.send': 'Gönder',
  'chat.typing': '{name} yazıyor…',
  'chat.loadOlder': 'Önceki mesajları yükle',
  'chat.today': 'Bugün',
  'chat.yesterday': 'Dün',
  'chat.you': 'Sen',
  'chat.noMessages': 'Henüz mesaj yok. İlk mesajı sen yaz.',
  'chat.status.queued': 'Gönderilmeyi bekliyor',
  'chat.status.sending': 'Gönderiliyor',
  'chat.status.sent': 'Gönderildi',
  'chat.status.delivered': 'İletildi',
  'chat.status.read': 'Okundu',
  'chat.status.failed': 'Gönderilemedi',
  'chat.retry': 'Tekrar dene',
  'chat.discard': 'Sil',
  'chat.cannotSend': 'Bu kişiye şu an mesaj gönderemezsin.',
  'chat.waitForReply': 'Bu kişi seni kişilerine eklediğinde ya da sana yazdığında cevap verebilirsin.',
  'chat.verifyToSend': 'Mesaj göndermek için önce e-posta adresini doğrula.',
  'chat.restrictedToSend': 'Mesajlaşma veli/vasi onayı tamamlandığında açılır.',
  'chat.encryptionNotice': 'Mesajlar sunucuya şifreli bağlantıyla (TLS) iletilir ve sunucuda saklanır. Uçtan uca şifreleme henüz yok.',
  'chat.unread': { one: '{count} okunmamış mesaj', other: '{count} okunmamış mesaj' },
  'chat.back': 'Sohbetlere dön',
  'contacts.title': 'Kişiler',
  'contacts.add': 'Ekle',
  'contacts.addLabel': 'Kullanıcı adıyla kişi ekle',
  'contacts.usernamePlaceholder': '@kullanıcıadı',
  'contacts.added': '{name} kişilerine eklendi.',
  'contacts.empty': 'Henüz kişin yok.',
  'contacts.message': 'Mesaj',
  'contacts.block': 'Engelle',
  'contacts.unblock': 'Engeli kaldır',
  'contacts.blocked': 'Engellendi',
  'contacts.hint': 'Birini eklemek onun sana yazabilmesini sağlar. Sen ona yazabilmek için onun da seni eklemesi ya da herkesten mesaj kabul etmesi gerekir.',
  'push.newMessage': 'Yeni mesaj',
  'push.newMessageHidden': 'Yeni bir mesajın var',
  'notifications.title': 'Bildirimler',
  'notifications.body': 'Uygulama kapalıyken yeni mesajlardan haberdar ol.',
  'notifications.enable': 'Bu cihazda bildirimleri aç',
  'notifications.disable': 'Bu cihazda kapat',
  'notifications.enabled': 'Bu cihazda bildirimler açık.',
  'notifications.denied': 'Tarayıcı bildirim iznini engelledi. İzni tarayıcının site ayarlarından açabilirsin.',
  'notifications.unsupported': 'Bu tarayıcı web bildirimlerini desteklemiyor.',
  'notifications.unavailable': 'Bildirimler şu an kullanılamıyor.',
  'notifications.preview': 'Bildirimde göster',
  'notifications.preview.full': 'Gönderen ve mesaj',
  'notifications.preview.sender': 'Yalnız gönderen',
  'notifications.preview.hidden': 'Hiçbir ayrıntı',
  'notifications.previewHint': 'Mesaj metni bildirim servisine şifreli iletilir ama kilit ekranında görünebilir.',
  'mute.label': 'Sessize al',
  'mute.1h': '1 saat',
  'mute.8h': '8 saat',
  'mute.1w': '1 hafta',
  'mute.forever': 'Her zaman',
  'mute.off': 'Sessizi kaldır',
  'mute.active': 'Sessizde',
  'report.message': 'Bildir',
  'report.user': 'Kullanıcıyı bildir',
  'report.title': 'Bildir',
  'report.reason': 'Neden bildiriyorsun?',
  'report.reason.spam': 'Spam veya istenmeyen mesaj',
  'report.reason.harassment': 'Taciz veya zorbalık',
  'report.reason.hate': 'Nefret söylemi',
  'report.reason.sexual_content': 'Cinsel içerik',
  'report.reason.child_safety': 'Bir çocuğun güvenliği risk altında',
  'report.reason.self_harm': 'Kendine zarar verme',
  'report.reason.violence': 'Şiddet veya tehdit',
  'report.reason.impersonation': 'Başkasının kimliğine bürünme',
  'report.reason.scam': 'Dolandırıcılık',
  'report.reason.other': 'Diğer',
  'report.details': 'Eklemek istediğin bilgi (isteğe bağlı)',
  'report.includeRecent': { one: 'Son {count} mesajı kanıt olarak ekle', other: 'Son {count} mesajı kanıt olarak ekle' },
  'report.evidenceNote': 'Yalnızca bildirdiğin mesaj ve eklemeyi seçtiğin mesajlar inceleme ekibiyle paylaşılır.',
  'report.alsoBlock': 'Bu kişiyi engelle',
  'report.submit': 'Bildirimi gönder',
  'report.sent': 'Teşekkürler. Bildirimin alındı ve incelenecek.',
  'report.emergency': 'Biri şu an tehlikedeyse hemen 112 Acil Çağrı Merkezi’ni ara.',
  'common.close': 'Kapat',
  'admin.nav': 'Yönetim',
  'admin.title': 'Yönetim',
  'admin.passkeyRequired': 'Yönetici işlemleri yalnız passkey ile açılmış ve 12 saatten yeni bir oturumda çalışır. Çıkış yapıp “Passkey ile giriş yap” ile tekrar gir.',
  'admin.roles': 'Rollerin: {roles}',
  'admin.tab.users': 'Kullanıcılar',
  'admin.tab.reports': 'Raporlar',
  'admin.tab.invites': 'Davetler',
  'admin.search': 'Kullanıcı adı, e-posta veya kimlik',
  'admin.state.active': 'Aktif',
  'admin.state.restricted': 'Kısıtlı',
  'admin.state.suspended': 'Askıda',
  'admin.suspend': 'Askıya al',
  'admin.unsuspend': 'Askıdan çıkar',
  'admin.suspendReason': 'Askıya alma nedeni (kayda geçer)',
  'admin.noResults': 'Sonuç yok.',
  'admin.reports.empty': 'Bekleyen rapor yok.',
  'admin.reports.priority': 'Öncelik {priority}',
  'admin.reports.evidence': 'Kanıt',
  'admin.reports.note': 'Karar notu (kayda geçer)',
  'admin.reports.action': 'İşlem yapıldı',
  'admin.reports.dismiss': 'Reddet',
  'admin.invites.create': 'Kod üret',
  'admin.invites.count': 'Adet',
  'admin.invites.note': 'Not',
  'admin.invites.newCodes': 'Yeni kodlar (yalnız şimdi gösterilir):',
  'admin.invites.used': '{used}/{max} kullanıldı',
  'admin.invites.revoke': 'İptal et',
  'admin.invites.revoked': 'İptal edildi',
  'conn.connected': 'Bağlı',
  'conn.reconnecting': 'Yeniden bağlanıyor…',
  'onboarding.title': 'DijitalApp’i nasıl kullanacaksın?',
  'onboarding.subtitle': 'Ana ekranını buna göre hazırlarız. İstediğin zaman değiştirebilirsin.',
  'onboarding.continue': 'Devam et',
  'onboarding.skip': 'Şimdilik atla',
  'onboarding.personaNote': 'Mod seçimi yalnızca görünümü değiştirir; yetki veya rol vermez.',
  'shell.activeSpace': 'Etkin alan',
  'shell.minorNotice': 'Hesabın yaşına uygun korumalı ayarlarla çalışıyor.',
  'shell.guardianPending': 'Bazı özellikler veli/vasi onayı tamamlanana kadar kapalı.',
  'module.disabled.title': 'Bu bölüm henüz açık değil',
  'module.disabled.body': '{module} geliştirme aşamasında ve şu an kapalı. Hazır olduğunda burada göreceksin.',
  'spaces.title': 'Alanlarım',
  'spaces.create': 'Yeni alan',
  'spaces.name': 'Alan adı',
  'spaces.type': 'Alan türü',
  'spaces.members': { one: '{count} üye', other: '{count} üye' },
  'spaces.type.personal': 'Kişisel',
  'spaces.type.family': 'Aile',
  'spaces.type.community': 'Topluluk',
  'spaces.type.school': 'Eğitim',
  'spaces.type.business': 'İş',
  'spaces.type.event': 'Etkinlik',
  'spaces.verificationRequired': 'Eğitim ve iş alanları kurum doğrulaması gerektirir.',
  'spaces.persona': 'Bu alandaki mod',
  'settings.title': 'Ayarlar',
  'settings.devices': 'Cihazlar',
  'settings.privacy': 'Gizlilik',
  'settings.appearance': 'Görünüm',
  'settings.theme.light': 'Açık',
  'settings.theme.dark': 'Koyu',
  'settings.theme.system': 'Sistem',
  'settings.language': 'Dil',
  'devices.current': 'Bu cihaz',
  'devices.lastActive': 'Son etkinlik: {date}',
  'devices.firstSeen': 'İlk giriş: {date}',
  'devices.signOut': 'Oturumu kapat',
  'devices.signOutOthers': 'Diğer tüm cihazlardan çıkış yap',
  'devices.count': { one: '{count} etkin cihaz', other: '{count} etkin cihaz' },
  'privacy.lockedByAge': 'Yaş politikası nedeniyle kilitli',
  'privacy.saved': 'Gizlilik ayarları kaydedildi',
  'privacy.profileDiscoverable': 'Profilim aramalarda bulunabilsin',
  'privacy.dmFromNonContacts': 'Kişilerim dışındakiler mesaj gönderebilsin',
  'privacy.lastSeen': 'Son görülme',
  'privacy.readReceipts': 'Okundu bilgisi',
  'privacy.phoneVisible': 'Telefon numaram görünsün',
  'privacy.audience.everyone': 'Herkes',
  'privacy.audience.contacts': 'Kişilerim',
  'privacy.audience.nobody': 'Hiç kimse',
  'common.save': 'Kaydet',
  'common.cancel': 'Vazgeç',
  'common.retry': 'Tekrar dene',
  'common.on': 'Açık',
  'common.off': 'Kapalı',
  'conn.offline': 'Çevrimdışı',
  'conn.connecting': 'Bağlanıyor…',
  'error.AUTH_INVALID_CREDENTIALS': 'E-posta/kullanıcı adı veya parola hatalı.',
  'error.AUTH_SESSION_EXPIRED': 'Oturumunun süresi doldu. Lütfen tekrar giriş yap.',
  'error.AUTH_REQUIRED': 'Devam etmek için giriş yapmalısın.',
  'error.AUTH_ORIGIN_REJECTED': 'İstek güvenlik kontrolünden geçmedi. Sayfayı yenileyip tekrar dene.',
  'error.AGE_BELOW_MINIMUM': 'Üzgünüz, bulunduğun ülkede bu yaşta DijitalApp hesabı açılamıyor.',
  'error.EMAIL_TAKEN': 'Bu e-posta adresiyle zaten bir hesap var.',
  'error.USERNAME_TAKEN': 'Bu kullanıcı adı kullanılamıyor.',
  'error.USERNAME_RESERVED': 'Bu kullanıcı adı ayrılmış, başka bir ad seç.',
  'error.VALIDATION_FAILED': 'Girdiğin bilgileri kontrol et.',
  'error.RATE_LIMITED': 'Çok fazla deneme yaptın. Biraz bekleyip tekrar dene.',
  'error.FORBIDDEN': 'Bu işlem için yetkin yok.',
  'error.NOT_FOUND': 'Aradığın şey bulunamadı.',
  'error.POLICY_LOCKED': 'Bu ayar yaşına uygun güvenlik politikası nedeniyle değiştirilemez.',
  'error.SPACE_VERIFICATION_REQUIRED': 'Bu alan türü kurum doğrulaması gerektirir.',
  'error.TERMS_NOT_ACCEPTED': 'Devam etmek için koşulları kabul etmelisin.',
  'error.ENTITLEMENT_LIMIT': 'Planındaki sınıra ulaştın.',
  'error.EMAIL_TOKEN_INVALID': 'Bu bağlantı geçersiz, kullanılmış ya da süresi dolmuş. Yeni bir bağlantı iste.',
  'error.PASSKEY_FAILED': 'Passkey doğrulanamadı. Tekrar dene.',
  'error.EMAIL_NOT_VERIFIED': 'Bu işlem için önce e-posta adresini doğrula.',
  'error.MESSAGING_NOT_ALLOWED': 'Bu kişiye şu an mesaj gönderemezsin.',
  'error.MESSAGE_TOO_LARGE': 'Mesaj çok uzun.',
  'error.AUTH_TICKET_INVALID': 'Canlı bağlantı kurulamadı. Tekrar deneniyor.',
  'error.PROTOCOL_INVALID_FRAME': 'Sunucuyla iletişimde bir sorun oldu.',
  'error.REGISTRATION_CLOSED': 'Yeni kayıtlar şu an kapalı.',
  'error.INVITE_INVALID': 'Davet kodu geçersiz, kullanılmış ya da süresi dolmuş.',
  'error.ADMIN_PASSKEY_REQUIRED': 'Yönetici işlemleri için son 12 saat içinde passkey ile giriş yapmış olmalısın.',
  'error.MESSAGE_EDIT_EXPIRED': 'Bu mesaj için düzenleme veya silme süresi doldu.',
  'error.ATTACHMENT_REJECTED': 'Bu dosya türü desteklenmiyor ya da dosya bozuk.',
  'error.STORAGE_QUOTA_EXCEEDED': 'Depolama alanın doldu. Eski dosyaları silerek yer açabilirsin.',
  'push.photo': '📷 Fotoğraf',
  'push.voice': '🎤 Sesli mesaj',
  'push.file': '📎 Dosya',
  'push.video': '🎬 Video',
  'error.PIN_LIMIT': 'En fazla 3 mesaj sabitlenebilir. Önce birinin sabitlemesini kaldır.',
  'chat.reply': 'Yanıtla',
  'chat.replyingTo': '{name} kişisine yanıt',
  'chat.originalMessage': 'Önceki bir mesaj',
  'chat.forward': 'İlet',
  'chat.forwarded': 'İletildi',
  'chat.forwardTitle': 'Mesajı ilet',
  'chat.forwardHint': 'En fazla 5 sohbet seçebilirsin.',
  'chat.forwardSent': 'İletildi.',
  'chat.forwardPartial': '{count} sohbete iletilemedi.',
  'chat.pin': 'Sabitle',
  'chat.unpin': 'Sabitlemeyi kaldır',
  'chat.pinned': 'Sabitlenmiş mesaj',
  'chat.react': 'Tepki ver',
  'chat.reactionsBy': '{emoji}: {names}',
  'chat.attachmentLabel': 'Ek',
  'error.AI_UNAVAILABLE': 'Yazım asistanı şu an kullanılamıyor.',
  'error.AI_CONSENT_REQUIRED': 'Yazım asistanını kullanmak için önce onay vermelisin.',
  'error.AI_QUOTA_EXCEEDED': 'Bugünkü yazım asistanı hakkın doldu. Yarın yeniden kullanabilirsin.',
  'error.AI_REFUSED': 'Yazım asistanı bu metni düzenlemedi.',
  'tpl.title': 'Şablonlar',
  'tpl.open': 'Şablon ekle',
  'tpl.search': 'Şablonlarda ara',
  'tpl.empty': 'Şablon bulunamadı.',
  'tpl.mine': 'Benim',
  'tpl.category.general': 'Genel',
  'tpl.category.education': 'Eğitim',
  'tpl.category.work': 'İş',
  'tpl.category.social': 'Sosyal',
  'tpl.saveDraft': 'Taslağı şablon olarak kaydet',
  'tpl.namePrompt': 'Şablon adı',
  'tpl.delete': 'Sil',
  'tpl.hint': 'Köşeli parantezli yerleri ([tarih] gibi) göndermeden önce doldur.',
  'ai.open': 'Yazım asistanı',
  'ai.title': 'Yazım asistanı',
  'ai.action.fix': 'Yazımı düzelt',
  'ai.action.shorten': 'Kısalt',
  'ai.action.formal': 'Resmi yap',
  'ai.action.friendly': 'Samimi yap',
  'ai.action.translate_en': 'İngilizceye çevir',
  'ai.action.translate_tr': 'Türkçeye çevir',
  'ai.consentTitle': 'Yazım asistanı hakkında',
  'ai.consentBody': 'Asistanı kullandığında, yalnız o an yazdığın taslak metin yapay zekâ sağlayıcısına ({provider}) gönderilir; sohbet geçmişin ve karşı tarafın mesajları gönderilmez. E-posta, telefon, IBAN, TC kimlik ve kart numaraları göndermeden önce gizlenir ve sonuçta geri konur. DijitalApp metni saklamaz; yalnız kaç kez kullandığını sayar. Sağlayıcının veri kullanımı kendi ticari koşullarına tabidir. Önerileri sen onaylamadan hiçbir şey gönderilmez. Onayını Yapay Zekâ sayfasından istediğin zaman geri çekebilirsin.',
  'ai.consentAccept': 'Anladım, kullanmak istiyorum',
  'ai.consentWithdraw': 'Onayı geri çek',
  'ai.e2eeWarning': 'Bu sohbet uçtan uca şifreli. Asistanı kullanırsan bu taslak şifrelemenin dışına çıkıp sağlayıcıya gönderilir.',
  'ai.suggestion': 'Öneri',
  'ai.use': 'Taslağa uygula',
  'ai.redacted': '{count} kişisel bilgi sağlayıcıdan gizlendi.',
  'ai.missing': 'Gizlenen {count} bilgi öneride yer almıyor; metni kontrol et.',
  'ai.remaining': 'Bugün kalan: {count}',
  'ai.working': 'Hazırlanıyor…',
  'ai.notForAccount': 'Yazım asistanı 18 yaş altı hesaplarda kullanılamaz.',
  'ai.unavailable': 'Yazım asistanı bu sunucuda henüz etkin değil.',
  'ai.pageIntro': 'Yazım asistanı mesaj taslaklarını düzeltir, kısaltır, tonunu değiştirir veya çevirir. Yalnız sen istediğinde ve yalnız taslağın gönderilir.',
  'ai.consentGiven': 'Onay verildi.',
  'ai.noConsent': 'Henüz onay vermedin.',
  'call.voice': 'Sesli ara',
  'call.video': 'Görüntülü ara',
  'call.incomingVoice': '{name} sesli arıyor…',
  'call.incomingVideo': '{name} görüntülü arıyor…',
  'call.calling': '{name} aranıyor…',
  'call.connecting': 'Bağlanıyor…',
  'call.accept': 'Cevapla',
  'call.acceptAudio': 'Sesli cevapla',
  'call.decline': 'Reddet',
  'call.hangup': 'Kapat',
  'call.mute': 'Sesi kapat',
  'call.unmute': 'Sesi aç',
  'call.cameraOff': 'Kamerayı kapat',
  'call.cameraOn': 'Kamerayı aç',
  'call.ended.hangup': 'Arama sona erdi.',
  'call.ended.rejected': 'Arama reddedildi.',
  'call.ended.missed': 'Cevap verilmedi.',
  'call.ended.busy': 'Kişi şu an başka bir aramada.',
  'call.ended.cancelled': 'Arama iptal edildi.',
  'call.ended.failed': 'Bağlantı kurulamadı.',
  'call.ended.disconnected': 'Bağlantı koptu.',
  'call.ended.answered_elsewhere': 'Başka bir cihazında cevaplandı.',
  'call.permissionDenied': 'Mikrofon/kamera izni verilmedi. Tarayıcı ayarlarından izin verebilirsin.',
  'call.encryptedNote': 'Şifreli bağlantı (DTLS-SRTP). Medya sunucu üzerinden aktarılır; karşı taraf IP adresini görmez.',
  'call.history': 'Aramalar',
  'call.noHistory': 'Henüz arama yok.',
  'call.incoming': 'Gelen',
  'call.outgoing': 'Giden',
  'call.missedLabel': 'Cevapsız',
  'call.duration': '{minutes} dk {seconds} sn',
  'call.unsupported': 'Bu tarayıcı aramaları desteklemiyor.',
  'push.call': '📞 Gelen arama',
  'call.ended.permission': 'Mikrofon/kamera izni verilmedi.',
  'call.ended.unsupported': 'Bu tarayıcı aramaları desteklemiyor.',
  'call.ended.not_allowed': 'Bu kişiyi arayamazsın (engel veya mesaj ayarları).',
  'push.videoCall': '🎥 Gelen görüntülü arama',
  'error.E2EE_IDENTITY_CHANGED': 'Doğruladığın biri şifreleme kimliğini değiştirdi. Göndermeden önce onu yeniden doğrula veya değişikliği kabul et (sohbet başlığındaki uyarı).',
  'e2ee.fileFailed': '🔒 Dosya bu cihazda açılamadı (anahtar yok ya da dosya değiştirilmiş).',
  'e2ee.unverifiedSender': 'Gönderen cihaz doğrulanamadı (yedekten geri yüklendi).',
  'e2ee.trust.verified': 'Doğrulandı',
  'e2ee.trust.unverified': 'Doğrulanmadı',
  'e2ee.trust.changed': 'Kimlik değişti',
  'e2ee.verifyTitle': '{name} kişisini doğrula',
  'e2ee.verifyIntro': 'Doğrulama, mesajlarının gerçekten {name} kişisinin cihazlarına gittiğinden emin olmanı sağlar. Yüz yüze veya bir görüntülü aramada yapın.',
  'e2ee.verifyEmoji': 'Emoji ile doğrula',
  'e2ee.verifyEmojiHint': 'İkinizin de DijitalApp açık olmalı. Karşı taraf isteği kabul edince iki ekranda emojiler görünür.',
  'e2ee.safetyCode': 'Güvenlik kodu ile doğrula',
  'e2ee.theirCode': '{name} kişisinin kodu',
  'e2ee.yourCode': 'Senin kodun',
  'e2ee.codeHint': 'Karşı taraf, kendi Ayarlar → Uçtan uca şifreleme ekranındaki "Senin kodun" ile buradaki "{name} kişisinin kodu"nu karşılaştırsın. Tamamen aynıysa doğrula.',
  'e2ee.codesMatch': 'Kodlar eşleşiyor, doğrula',
  'e2ee.noIdentity': 'Bu kişi henüz şifrelemeyi kurmamış.',
  'e2ee.requestIncoming': '{name} seninle doğrulama yapmak istiyor.',
  'e2ee.requestIncomingSelf': 'Diğer cihazın bu cihazla doğrulama yapmak istiyor.',
  'e2ee.accept': 'Kabul et',
  'e2ee.decline': 'Reddet',
  'e2ee.waitingAccept': 'Karşı tarafın isteği kabul etmesi bekleniyor…',
  'e2ee.emojiHint': 'İki ekranda da aynı emojiler aynı sırayla görünüyor mu?',
  'e2ee.match': 'Evet, eşleşiyor',
  'e2ee.noMatch': 'Hayır, eşleşmiyor',
  'e2ee.waitingOther': 'Karşı tarafın onayı bekleniyor…',
  'e2ee.done': 'Doğrulama tamamlandı ✓',
  'e2ee.cancelled': 'Doğrulama iptal edildi.',
  'e2ee.changedTitle': '{name} güvenlik kimliğini değiştirdi',
  'e2ee.changedBody': 'Yeni bir cihaz kurmuş ya da şifreleme kimliğini sıfırlamış olabilir; bu durumda mesajlar başka birine gidebilir. Emin olmak için yeniden doğrula. Doğrulamadan kabul edersen mesajlar yeni kimliğe gider.',
  'e2ee.acceptChange': 'Doğrulamadan kabul et',
  'e2ee.reverify': 'Yeniden doğrula',
  'e2ee.deviceUnverifiedTitle': 'Bu cihaz henüz doğrulanmadı',
  'e2ee.deviceUnverifiedBody': 'Şifreli sohbetleri bu cihazda okuyup yazabilmek için cihazı diğer cihazınla (emoji) doğrula. Geçmiş mesajlar için kurtarma anahtarını da girebilirsin.',
  'e2ee.verifyThisDevice': 'Diğer cihazımla doğrula',
  'e2ee.enterRecovery': 'Kurtarma anahtarı',
  'e2ee.restore': 'Geçmişi geri yükle',
  'e2ee.restored': '{count} sohbet anahtarı geri yüklendi.',
  'e2ee.wrongRecovery': 'Kurtarma anahtarı bu yedekle eşleşmiyor.',
  'e2ee.resetTitle': 'Şifreleme kimliğini sıfırla',
  'e2ee.resetBody': 'Yalnız tüm cihazlarını kaybettiysen kullan. Yeni bir şifreleme kimliği ve yeni bir kurtarma anahtarı oluşturulur; kişilerin "kimlik değişti" uyarısı görür ve seni yeniden doğrulaması gerekir. Eski mesajlar ancak eski kurtarma anahtarıyla okunabilir.',
  'e2ee.reset': 'Kimliği sıfırla',
  'e2ee.recoveryTitle': 'Kurtarma anahtarın',
  'e2ee.recoveryBody': 'Tüm cihazlarını kaybedersen şifreli mesaj geçmişini geri getirmenin tek yolu bu anahtar. Parola yöneticisine veya kâğıda kaydet ve kimseyle paylaşma. DijitalApp bu anahtarı göremez ve kaybedersen kurtaramaz.',
  'e2ee.saved': 'Kaydettim',
  'e2ee.settingsTitle': 'Uçtan uca şifreleme',
  'e2ee.thisDevice': 'Bu cihaz',
  'e2ee.showRecovery': 'Kurtarma anahtarını göster',
  'e2ee.notOnThisDevice': 'Bu cihazda yok; diğer cihazınla doğrulayınca gelir.',
  'e2ee.loading': 'Şifreleme hazırlanıyor…',
  'error.E2EE_REQUIRED': 'Bu sohbet uçtan uca şifreli; mesaj şifrelenmeden gönderilemez.',
  'error.E2EE_UNAVAILABLE': 'Uçtan uca şifreleme için sohbetteki herkesin en az bir cihazında şifrelemenin kurulmuş olması gerekir (DijitalApp bir kez açılınca kurulur).',
  'error.E2EE_UNSUPPORTED': 'Bu özellik uçtan uca şifreli sohbetlerde henüz kullanılamıyor.',
  'push.encrypted': '🔒 Şifreli mesaj',
  'e2ee.label': 'Uçtan uca şifreli (deneysel)',
  'e2ee.enable': 'Uçtan uca şifrelemeyi aç',
  'e2ee.enableConfirm': 'Bu sohbette uçtan uca şifreleme açılacak. Bu işlem geri alınamaz. Şifreli sohbetlerde şimdilik ek dosya, bağlantı önizlemesi, düzenleme, tepki ve iletme kullanılamaz; yeni bir cihaz eski şifreli mesajları göremez. Devam edilsin mi?',
  'e2ee.notice': 'Bu sohbetteki yeni mesajlar uçtan uca şifreli: içeriği DijitalApp sunucusu dahil kimse göremez. Deneysel: cihaz doğrulaması henüz yok.',
  'e2ee.cannotDecrypt': '🔒 Bu mesaj bu cihazda çözülemiyor (cihaz mesajdan sonra eklenmiş olabilir).',
  'e2ee.decrypting': '🔒 Çözülüyor…',
  'e2ee.encryptedBadge': 'Şifreli',
  'e2ee.notReady': 'Şifreleme bu cihazda hazırlanıyor; birkaç saniye sonra yeniden dene.',
  'e2ee.unsupportedBrowser': 'Bu tarayıcı uçtan uca şifrelemeyi desteklemiyor.',
  'chat.star': 'Yıldızla',
  'chat.unstar': 'Yıldızı kaldır',
  'chat.starred': 'Yıldızlı mesajlar',
  'chat.noStarred': 'Henüz yıldızlı mesaj yok. Bir mesajı yıldızlamak için mesaj seçeneklerinden "Yıldızla"yı seç.',
  'chat.openInChat': 'Sohbette göster',
  'chat.info': 'Bilgi',
  'chat.infoTitle': 'Mesaj bilgisi',
  'chat.readBy': 'Okudu',
  'chat.deliveredTo': 'İletildi',
  'chat.pendingTo': 'Henüz iletilmedi',
  'chat.readsHidden': 'Okundu bilgisini kapattığın için kimin okuduğu gösterilmiyor.',
  'chat.previewLoading': 'Bağlantı önizlemesi hazırlanıyor…',
  'chat.removePreview': 'Önizlemeyi kaldır',
  'error.ATTACHMENT_MALWARE': 'Bu dosyada zararlı yazılım bulundu; gönderilmedi.',
  'error.ATTACHMENT_SCAN_UNAVAILABLE': 'Dosya güvenlik taraması şu an yapılamıyor. Biraz sonra yeniden dene.',
  'chat.attach': 'Dosya ekle',
  'chat.record': 'Sesli mesaj kaydet',
  'chat.stopRecording': 'Kaydı bitir ve gönder',
  'chat.cancelRecording': 'Kaydı iptal et',
  'chat.recording': 'Kaydediliyor… {seconds} sn',
  'chat.uploading': 'Yükleniyor…',
  'chat.download': 'İndir',
  'chat.micDenied': 'Mikrofon izni verilmedi. Tarayıcı ayarlarından izin verebilirsin.',
  'chat.voiceMessage': 'Sesli mesaj',
  'chat.tooLarge': 'Dosya çok büyük (en fazla {mb} MB).',
  'chat.searchMessages': 'Mesajlar',
  'group.new': 'Yeni grup',
  'group.title': 'Grup adı',
  'group.description': 'Açıklama',
  'group.pickMembers': 'Kişilerinden üye seç (sonra da ekleyebilirsin):',
  'group.addHint': 'Bir kişi ancak gizlilik ayarı izin veriyorsa eklenir (varsayılan: yalnız onu ekleyen kişileri).',
  'group.create': 'Grubu oluştur',
  'group.info': 'Grup bilgisi',
  'group.memberCount': { one: '{count} üye', other: '{count} üye' },
  'group.someoneTyping': 'Biri yazıyor…',
  'group.onlyAdmins': 'Yalnız yöneticiler mesaj gönderebilsin (duyuru modu)',
  'group.role.owner': 'Sahip',
  'group.role.admin': 'Yönetici',
  'group.makeAdmin': 'Yönetici yap',
  'group.makeMember': 'Yöneticilikten al',
  'group.remove': 'Çıkar',
  'group.addMembers': 'Üye ekle',
  'group.add': 'Ekle',
  'group.leave': 'Gruptan ayrıl',
  'group.leaveConfirm': 'Bu gruptan ayrılmak istiyor musun?',
  'group.skipped': 'Şu kişiler gizlilik ayarları nedeniyle eklenemedi: {names}',
  'error.SPACE_LINK_INVALID': 'Bu davet bağlantısı geçersiz ya da süresi dolmuş.',
  'error.GROUP_LINK_INVALID': 'Bu grup bağlantısı geçersiz, iptal edilmiş ya da süresi dolmuş.',
  'error.GROUP_FULL': 'Grup üye sınırına ulaştı.',
  'group.inviteLink': 'Davet bağlantısı',
  'group.linkHint': 'Bağlantıya sahip herkes gruba katılabilir veya katılma isteği gönderebilir. Yalnız güvendiğin kişilerle paylaş.',
  'group.noLink': 'Etkin bağlantı yok.',
  'group.createLink': 'Bağlantı oluştur',
  'group.resetLink': 'Yeni bağlantı oluştur (eskisi geçersiz olur)',
  'group.revokeLink': 'Bağlantıyı iptal et',
  'group.requireApproval': 'Katılmak için yönetici onayı gereksin',
  'group.linkExpiry': 'Geçerlilik',
  'group.expiry.never': 'İptal edilene kadar',
  'group.expiry.24': '1 gün',
  'group.expiry.168': '1 hafta',
  'group.expiry.720': '30 gün',
  'group.linkActive': 'Etkin bağlantı: {date} tarihinde oluşturuldu · {uses} kullanım',
  'group.linkExpires': 'Bitiş: {date}',
  'group.linkOnce': 'Bağlantı yalnız şimdi gösterilir; güvenlik için saklanmaz. Kaybedersen yenisini oluştur.',
  'group.copyLink': 'Kopyala',
  'group.linkCopied': 'Kopyalandı',
  'group.joinRequests': 'Katılma istekleri',
  'group.noRequests': 'Bekleyen istek yok.',
  'group.approve': 'Onayla',
  'group.reject': 'Reddet',
  'group.previouslyRemoved': 'daha önce çıkarıldı',
  'group.pendingBadge': '{count} istek',
  'join.title': 'Gruba katıl',
  'join.join': 'Katıl',
  'join.request': 'Katılma isteği gönder',
  'join.requested': 'İsteğin gönderildi. Bir yönetici onayladığında grup sohbetlerinde görünecek.',
  'join.approvalNote': 'Bu gruba katılmak için yönetici onayı gerekiyor.',
  'join.open': 'Sohbeti aç',
  'join.missingToken': 'Bağlantıda davet bilgisi yok.',
  'join.privacyNote': 'Katıldığında grup üyeleri adını ve kullanıcı adını görebilir.',
  'privacy.groupAdd': 'Beni gruplara kim ekleyebilir',
  'chat.online': 'çevrimiçi',
  'chat.lastSeen': 'son görülme: {date}',
  'chat.edit': 'Düzenle',
  'chat.edited': 'düzenlendi',
  'chat.editing': 'Mesajı düzenliyorsun',
  'chat.save': 'Kaydet',
  'chat.deleteForMe': 'Benden sil',
  'chat.deleteForEveryone': 'Herkesten sil',
  'chat.deleted': 'Bu mesaj silindi',
  'chat.messageActions': 'Mesaj seçenekleri',
  'auth.inviteCode': 'Davet kodu',
  'auth.inviteHint': 'DijitalApp şu an davetle açılan kapalı beta aşamasında.',
  'auth.registrationClosed': 'Yeni kayıtlar şu an kapalı. Hesabın varsa giriş yapabilirsin.',
  'error.NETWORK': 'Sunucuya ulaşılamıyor. Bağlantını kontrol et.',
  'error.UNKNOWN': 'Beklenmeyen bir sorun oluştu. Tekrar dene.',
  'channel.title': 'Kanallar',
  'channel.intro': 'Kanallar birden çoğa yayındır: yalnız yöneticiler yazar, aboneler okur ve birbirini göremez.',
  'channel.mine': 'Kanallarım',
  'channel.none': 'Henüz bir kanala abone değilsin.',
  'channel.directory': 'Herkese açık kanallar',
  'channel.search': 'Kanal ara',
  'channel.noResults': 'Kanal bulunamadı.',
  'channel.subscribe': 'Abone ol',
  'channel.subscribers': { one: '{count} abone', other: '{count} abone' },
  'channel.privacyNote': 'Abone olduğunda kanal yöneticileri seni abone listesinde görebilir; diğer aboneler göremez.',
  'channel.adultsOnly': 'Herkese açık kanal dizini yalnız yetişkin hesaplar için. Özel kanallara davet bağlantısıyla katılabilirsin.',
  'channel.create': 'Kanal oluştur',
  'channel.name': 'Kanal adı',
  'channel.public': 'Herkese açık (dizinde görünsün)',
  'channel.publicNote': 'Herkese açık kanallar dizinde listelenir; yetişkin hesaplar bulup abone olabilir.',
  'channel.privateNote': 'Özel kanala yalnız davet bağlantısıyla katılınır (kanal bilgisinden bağlantı oluştur).',
  'channel.subscriberNote': 'Bu bir kanal: yalnız yöneticiler mesaj gönderebilir.',
  'community.title': 'Topluluk',
  'community.announcements': 'Duyurular',
  'community.announcementsAdmin': 'Tüm üyelere duyuru gönder',
  'community.announcementsMember': 'Yöneticilerin duyuruları',
  'community.groups': 'Gruplar',
  'community.noGroups': 'Henüz grup yok.',
  'community.closed': 'kapalı',
  'community.newGroup': 'Yeni grup adı',
  'community.openGroup': 'Açık grup (topluluk üyeleri kendileri katılabilir)',
  'community.invite': 'Davet bağlantısı',
  'community.inviteNote': 'Bağlantıya sahip yetişkinler topluluğa katılır ve duyurulara abone olur.',
  'community.inviteFamilyNote': 'Bağlantıyı yalnız aile üyelerinle paylaş: aile alanlarına reşit olmayanlar da katılabilir.',
  'community.createLink': 'Yeni bağlantı oluştur (eskisi geçersiz olur)',
  'community.leave': 'Topluluktan ayrıl',
  'community.leaveConfirm': 'Topluluktan ayrılırsan duyuru kanalından ve topluluk gruplarından da çıkarsın. Devam edilsin mi?',
  'community.joinTitle': 'Topluluğa katıl',
  'community.open': 'Topluluğu aç',
  'community.joinPrivacyNote': 'Katıldığında topluluk yöneticileri adını görebilir; grupların üyeleri sen katıldığında görür.',
  'nav.calendar': 'Takvim',
  'planner.title': 'Takvim ve görevler',
  'planner.calendar': 'Takvim',
  'planner.tasks': 'Görevler',
  'planner.personal': 'Kişisel',
  'planner.prevMonth': 'Önceki ay',
  'planner.nextMonth': 'Sonraki ay',
  'planner.today': 'Bugün',
  'planner.noEvents': 'Bu ay etkinlik yok.',
  'planner.allDay': 'Tüm gün',
  'planner.cancelled': 'İptal edildi',
  'planner.responseCounts': '{going} katılıyor · {maybe} belki · {declined} katılmıyor',
  'planner.yourResponse': 'Yanıtın',
  'planner.response.going': 'Katılıyorum',
  'planner.response.maybe': 'Belki',
  'planner.response.declined': 'Katılmıyorum',
  'planner.cancel': 'İptal et',
  'planner.delete': 'Sil',
  'planner.cancelConfirm': 'Etkinlik herkes için iptal edilsin mi?',
  'planner.deleteConfirm': 'Etkinlik silinsin mi?',
  'planner.newEvent': 'Yeni etkinlik',
  'planner.eventTitle': 'Etkinlik adı',
  'planner.where': 'Nerede görünsün',
  'planner.date': 'Tarih',
  'planner.start': 'Başlangıç',
  'planner.end': 'Bitiş',
  'planner.location': 'Yer',
  'planner.description': 'Açıklama',
  'planner.scopeNote': 'Kişisel öğeleri yalnız sen görürsün; alan ve grup öğelerini o alanın/grubun üyeleri görür. Uçtan uca şifreli gruplarda takvim kullanılamaz.',
  'planner.addEvent': 'Etkinlik ekle',
  'planner.myTasks': 'Bana ait görevler',
  'planner.show': 'Göster',
  'planner.showDone': 'Tamamlananları göster',
  'planner.noTasks': 'Görev yok.',
  'planner.assignedTo': 'Atanan: {name}',
  'planner.due': 'Son: {date}',
  'planner.deleteTaskConfirm': 'Görev silinsin mi?',
  'planner.newTask': 'Yeni görev',
  'planner.taskTitle': 'Görev',
  'planner.assignee': 'Atanan kişi',
  'planner.unassigned': 'Atanmamış',
  'planner.dueDate': 'Son tarih',
  'planner.addTask': 'Görev ekle',
  'nav.learn': 'Eğitim',
  'error.EDU_INVITE_INVALID': 'Bu okul daveti geçersiz, kullanılmış ya da süresi dolmuş.',
  'learn.title': 'Eğitim',
  'learn.classes': 'Sınıflarım',
  'learn.teachers': 'Öğretmen: {names}',
  'learn.studentCount': { one: '{count} öğrenci', other: '{count} öğrenci' },
  'learn.role.teacher': 'Öğretmen',
  'learn.role.student': 'Öğrenci',
  'learn.role.guardian': 'Veli',
  'learn.childTitle': '{name} — ödev durumu',
  'learn.noClasses': 'sınıf yok',
  'learn.noAssignments': 'Ödev yok.',
  'learn.feedbackLine': 'Öğretmen: {text}',
  'learn.late': 'Geç',
  'learn.status.not_submitted': 'Teslim edilmedi',
  'learn.status.missing': 'Eksik',
  'learn.status.submitted': 'Teslim edildi',
  'learn.status.returned': 'Değerlendirildi',
  'learn.guardianNote': 'Veli olarak ödev durumunu, notu ve öğretmen geri bildirimini görürsün; çocuğunun cevaplarını ve mesajlarını görmezsin.',
  'learn.myGuardians': 'Velilerim',
  'learn.myGuardiansNote': 'Bu kişiler okulun onayıyla velin olarak bağlandı ve ödev durumunu, notunu görebilir; cevaplarını ve mesajlarını göremez.',
  'learn.empty': 'Henüz bir sınıfın yok. Öğretmeninden sınıf bağlantısı iste ya da okul davetini aç.',
  'learn.request.title': 'Okulunu ekle',
  'learn.request.note': 'Okul alanlarını yalnız DijitalApp ekibi açar: başvurunu inceler ve kurum bilgisini doğrular. Onaydan sonra okul yöneticisi sen olursun.',
  'learn.request.schoolName': 'Okul adı',
  'learn.request.city': 'Şehir',
  'learn.request.message': 'Not (görevin, iletişim)',
  'learn.request.submit': 'Başvur',
  'learn.request.pending': 'İnceleniyor',
  'learn.request.approved': 'Onaylandı',
  'learn.request.rejected': 'Reddedildi',
  'learn.link': 'Davet bağlantısı',
  'learn.verified': 'Doğrulanmış okul',
  'learn.people': 'Okul kişileri',
  'learn.inviteTeacher': 'Öğretmen daveti oluştur',
  'learn.pickStudent': 'Öğrenci seç',
  'learn.inviteGuardian': 'Veli daveti oluştur',
  'learn.teacherLinkNote': 'Tek kullanımlık, 7 gün geçerli; yalnız yetişkin hesaplar kullanabilir. Öğretmene doğrudan ilet.',
  'learn.guardianLinkNote': 'Tek kullanımlık, 7 gün geçerli; yalnız seçtiğin öğrencinin velisine (yetişkin) doğrudan ilet.',
  'learn.className': 'Sınıf adı',
  'learn.subject': 'Ders',
  'learn.createClass': 'Sınıf oluştur',
  'learn.back': 'Geri',
  'learn.studentsTitle': { one: '{count} öğrenci', other: '{count} öğrenci' },
  'learn.noStudents': 'Henüz öğrenci yok.',
  'learn.classLink': 'Sınıf bağlantısı oluştur',
  'learn.classLinkNote': 'Bağlantıyı yalnız öğrencilerinle paylaş (1 hafta geçerli). Reşit olmayanlar yalnız veli onayı verilmiş hesapla katılabilir.',
  'learn.newAssignment': 'Yeni ödev',
  'learn.assignmentTitle': 'Başlık',
  'learn.instructions': 'Yönerge',
  'learn.assign': 'Ödev ver',
  'learn.assignments': 'Ödevler',
  'learn.leaveClass': 'Sınıftan ayrıl',
  'learn.leaveConfirm': 'Sınıftan ayrılmak istiyor musun?',
  'learn.yourAnswer': 'Cevabın',
  'learn.submitNote': 'Öğretmen değerlendirene kadar düzenleyebilirsin. Yalnız öğretmenin görür.',
  'learn.submit': 'Teslim et',
  'learn.resubmit': 'Güncelle',
  'learn.counts': '{submitted}/{students} teslim · {returned} değerlendirildi',
  'learn.submissions': 'Teslimler',
  'learn.deleteAssignmentConfirm': 'Ödev silinsin mi?',
  'learn.feedback': 'Geri bildirim',
  'learn.grade': 'Not',
  'learn.return': 'Değerlendir',
  'learn.updateReturn': 'Güncelle',
  'learn.join.title': 'Okul daveti',
  'learn.join.teacher': '{school} okuluna öğretmen olarak katılıyorsun.',
  'learn.join.guardian': '{school} okulunda {name} adlı öğrencinin velisi olarak bağlanıyorsun.',
  'learn.join.class': '{school} — {className} sınıfına öğrenci olarak katılıyorsun.',
  'learn.join.teacherNote': 'Öğretmenler sınıf açar, ödev verir ve öğrencilerinin teslimlerini görür.',
  'learn.join.guardianNote': 'Çocuğunun ödev durumunu, notunu ve öğretmen geri bildirimini görürsün; cevaplarını ve mesajlarını görmezsin. Çocuğun seni velisi olarak görür.',
  'learn.join.classNote': 'Öğretmenlerinin adını ve kendi teslimlerini görürsün; sınıf arkadaşların seni bir sınıf listesinde görmez.',
  'learn.join.accept': 'Kabul et',
  'admin.tab.schools': 'Okul başvuruları',
  'admin.schools.note': 'Onay, başvurana doğrulanmış bir okul alanı açar ve onu okul yöneticisi yapar. Kurumu bant dışında (resmî yazı, kurum e-postası, telefon) doğrulamadan onaylama.',
  'admin.schools.none': 'Bekleyen başvuru yok.',
  'admin.schools.reviewNote': 'İnceleme notu (başvurana gösterilir)',
  'admin.schools.approve': 'Onayla',
  'admin.schools.reject': 'Reddet',
  'admin.schools.approveConfirm': 'Kurum doğrulandı mı? Onay, doğrulanmış bir okul alanı oluşturur.',
  'quiz.title': 'Quizler',
  'quiz.new': 'Yeni quiz',
  'quiz.none': 'Henüz quiz yok.',
  'quiz.state.draft': 'Taslak',
  'quiz.state.published': 'Yayında',
  'quiz.state.closed': 'Kapandı',
  'quiz.meta': '{questions} soru · {points} puan',
  'quiz.minutes': { one: '{count} dk', other: '{count} dk' },
  'quiz.stats': '{submitted}/{students} tamamladı · ort. {average}',
  'quiz.edit': 'Düzenle',
  'quiz.publish': 'Yayınla',
  'quiz.publishConfirm': 'Yayınlanan quizin soruları ve cevap anahtarı artık değiştirilemez. Yayınlansın mı?',
  'quiz.results': 'Sonuçlar',
  'quiz.close': 'Kapat',
  'quiz.deleteConfirm': 'Quiz silinsin mi?',
  'quiz.byQuestion': 'Soru bazında',
  'quiz.correctRate': '%{rate} doğru',
  'quiz.cancel': 'Vazgeç',
  'quiz.timeLimit': 'Süre (dk)',
  'quiz.showAnswers': 'Doğru cevaplar',
  'quiz.policy.after_submit': 'Teslimden hemen sonra gösterilsin',
  'quiz.policy.after_close': 'Quiz kapanınca gösterilsin',
  'quiz.policy.never': 'Gösterilmesin (yalnız puan)',
  'quiz.question': 'Soru {n}',
  'quiz.prompt': 'Soru metni',
  'quiz.option': 'Seçenek {n}',
  'quiz.markCorrect': 'Seçenek {n} doğru cevap',
  'quiz.removeOption': 'Seçenek {n}i kaldır',
  'quiz.addOption': 'Seçenek ekle',
  'quiz.points': 'Puan',
  'quiz.removeQuestion': 'Soruyu kaldır',
  'quiz.correctHint': 'Her sorunun doğru cevabını soldaki düğmeyle işaretle. Cevap anahtarı sunucuda tutulur; öğrenciler seçtiğin zamana kadar göremez.',
  'quiz.addQuestion': 'Soru ekle',
  'quiz.saveDraft': 'Taslağı kaydet',
  'quiz.status.not_started': 'Başlanmadı',
  'quiz.status.in_progress': 'Devam ediyor',
  'quiz.status.submitted': 'Tamamlandı',
  'quiz.status.missing': 'Kaçırıldı',
  'quiz.start': 'Başla',
  'quiz.startConfirm': 'Süre başladığında durmaz: {count} dakikan olacak. Başlansın mı?',
  'quiz.resume': 'Devam et',
  'quiz.view': 'Sonucu gör',
  'quiz.score': 'Puan: {score}/{max}',
  'quiz.answersLater': 'Doğru cevaplar öğretmenin seçtiği zamanda gösterilecek.',
  'quiz.pointsShort': { one: '{count} puan', other: '{count} puan' },
  'quiz.submit': 'Teslim et',
  'quiz.blankConfirm': '{count} soru boş. Yine de teslim edilsin mi?',
  'quiz.oneAttempt': 'Tek hakkın var; teslimden sonra değiştiremezsin. Süre bitince cevapların otomatik teslim edilir.',
  'study.title': 'Çalışma planım',
  'study.prevWeek': 'Önceki hafta',
  'study.nextWeek': 'Sonraki hafta',
  'study.progress': '{done}/{planned} dk çalışıldı · {blocksDone}/{blocksTotal} blok',
  'study.weekProgress': 'Haftalık ilerleme',
  'study.due': 'Bu hafta yapılacaklar',
  'study.planned': 'Planlandı',
  'study.auto': 'Haftayı planla',
  'study.autoCreated': { one: '{count} blok eklendi.', other: '{count} blok eklendi.' },
  'study.autoNothing': 'Eklenecek yeni bir şey yok.',
  'study.autoNote': 'Ödev ve quizler için son tarihten bir gün önceye, hedeflerin için haftanın kalan günlerine çalışma blokları önerilir. Geçmiş günlere blok konmaz; tekrar basınca aynı şeyler eklenmez.',
  'study.goals': 'Hedeflerim',
  'study.goalLine': 'bu hafta {done}/{target} dk',
  'study.goalNoTarget': 'bu hafta {done} dk',
  'study.goalDone': 'Tamamlandı',
  'study.newGoal': 'Yeni hedef',
  'study.goalTitle': 'Hedef',
  'study.weeklyMinutes': 'Haftalık dk',
  'study.addGoal': 'Hedef ekle',
  'study.minutes': { one: '{count} dk', other: '{count} dk' },
  'study.kind.custom': 'Serbest',
  'study.kind.homework': 'Ödev',
  'study.kind.quiz': 'Quiz',
  'study.kind.goal': 'Hedef',
  'study.removeBlock': '{title} bloğunu kaldır',
  'study.day': 'Gün',
  'study.blockTitle': 'Ne çalışacaksın',
  'study.minutesLabel': 'Dk',
  'study.forGoal': 'Hedef',
  'study.addBlock': 'Ekle',
  'study.share': 'İlerlememi velilerimle paylaş',
  'study.privacy': 'Planın yalnız sana aittir; öğretmenler görmez. Paylaşırsan velilerin yalnız haftalık toplamları ve hedef yüzdelerini görür, blok başlıklarını görmez.',
  'study.notShared': 'Çalışma planı paylaşılmıyor (paylaşmak çocuğunun kararıdır).',
  'tutor.title': 'AI öğretmen',
  'tutor.intro': 'Konuyu anlaman için ipuçları verir, soru sorar, kavramı açıklar. Ödevini senin yerine yapmaz.',
  'tutor.consent.hints': 'Cevabı hazır vermez; ipucu ve sorularla seni yönlendirir. Yanılabilir; önemli konuları öğretmenine danış.',
  'tutor.consent.redaction': 'Yazdıkların bir yapay zekâ hizmetine gönderilir; telefon, e-posta, kimlik numarası gibi kişisel bilgiler gönderilmeden önce gizlenir.',
  'tutor.consent.retention': 'Konuşmaların 30 gün saklanır, sonra silinir; istediğin zaman kendin silebilirsin.',
  'tutor.consent.visibility': 'Konuşmalarını yalnız sen görürsün. Öğretmenin ve velin yalnız kaç mesaj yazıldığını görür.',
  'tutor.consent.guardian': '18 yaşından küçük olduğun için velinin de onay vermesi gerekir.',
  'tutor.consent.accept': 'Anladım, kullanmak istiyorum',
  'tutor.consent.withdraw': 'AI öğretmen iznimi geri al',
  'tutor.reason.account': 'Hesabın şu an AI öğretmeni kullanamıyor (e-posta doğrulaması veya veli onaylı kayıt gerekli).',
  'tutor.reason.guardian_approval_required': 'Velinin AI öğretmen için onay vermesi bekleniyor. Velin Eğitim sayfasından onaylayabilir.',
  'tutor.reason.quiz_in_progress': 'Bu sınıfta süren bir quizin var; quiz bitene kadar AI öğretmen kapalı.',
  'tutor.reason.quota': 'Bugünkü AI öğretmen hakkın doldu; yarın yeniden kullanabilirsin.',
  'tutor.newSession': 'Yeni konuşma başlat',
  'tutor.remaining': { one: 'Bugün {count} mesaj hakkın kaldı.', other: 'Bugün {count} mesaj hakkın kaldı.' },
  'tutor.safety': 'Önemli',
  'tutor.thinking': 'AI öğretmen düşünüyor…',
  'tutor.redacted': { one: '{count} kişisel bilgi gönderilmeden önce gizlendi.', other: '{count} kişisel bilgi gönderilmeden önce gizlendi.' },
  'tutor.ask': 'Neyi anlamadın? Ne denedin?',
  'tutor.turnsLeft': { one: 'Bu konuşmada {count} mesaj kaldı', other: 'Bu konuşmada {count} mesaj kaldı' },
  'tutor.send': 'Gönder',
  'tutor.teacher.enable': 'Bu sınıfta AI öğretmeni aç',
  'tutor.teacher.note': 'Öğrenciler ipucu ve açıklama alır, hazır cevap almaz; quiz sırasında kapalıdır. 18 yaşından küçükler için veli onayı da gerekir. Konuşmaları siz göremezsiniz, yalnız kullanım sayılarını görürsünüz.',
  'tutor.teacher.usage': 'Bu hafta {students} öğrenci, {messages} mesaj',
  'tutor.guardian.approve': 'Çocuğumun AI öğretmeni kullanmasına izin veriyorum',
  'tutor.guardian.note': 'Öğretmeni sınıfta açtıysa ve çocuğun da kabul ettiyse kullanılabilir. İpucu verir, ödevi yapmaz; kişisel bilgiler gizlenir; konuşmalar 30 gün sonra silinir. Konuşmaların içeriğini göremezsiniz, yalnız haftalık mesaj sayısını görürsünüz.',
  'tutor.guardian.usage': { one: 'Bu hafta {count} mesaj', other: 'Bu hafta {count} mesaj' },
  'admin.tab.system': 'Sistem sağlığı',
  'admin.tab.config': 'Ayarlar',
  'admin.tab.audit': 'Denetim kaydı',
  'admin.tab.security': 'Güvenlik olayları',
  'admin.tab.ai': 'AI kullanımı',
  'adminOps.reasonPrompt': 'Bu değişikliğin nedeni (denetim kaydına yazılır):',
  'adminOps.reasonShort': 'Lütfen en az 5 karakterlik bir neden yaz.',
  'adminOps.config.note': 'Değişiklikler hemen etkinleşir ve nedenleriyle birlikte denetim kaydına yazılır. Yalnız süper yöneticiler değiştirebilir.',
  'adminOps.settings': 'Genel ayarlar',
  'adminOps.registrationMode': 'Kayıt modu',
  'adminOps.registration.open': 'Açık (herkes kayıt olabilir)',
  'adminOps.registration.invite': 'Davetle (davet kodu gerekir)',
  'adminOps.registration.closed': 'Kapalı',
  'adminOps.source.console': 'panelden ayarlandı',
  'adminOps.source.env': 'sunucu varsayılanı (.env)',
  'adminOps.range': 'aralık {min}–{max} · varsayılan {def}',
  'adminOps.save': 'Kaydet',
  'adminOps.flags': 'Özellikler (feature flag)',
  'adminOps.flagsNote': 'Bir özelliği kapatmak onu herkes için kapatır. Çocuk güvenliği tabanı bayrak değildir; hiçbir bayrak onu gevşetemez.',
  'adminOps.overrides': { one: '{count} istisna', other: '{count} istisna' },
  'adminOps.plan': 'Plan hakları',
  'adminOps.secretsTitle': 'Gizli anahtarlar neden burada değil?',
  'adminOps.secretsNote': 'Veritabanı şifresi, e-posta (SMTP), Web Push özel anahtarı, TURN sırrı, AI API anahtarı ve yedekleme bilgileri yalnız sunucudaki, yalnız yöneticinin okuyabildiği /etc/dijitalapp/*.env dosyalarında durur. Panelden yönetilselerdi ele geçirilen tek bir admin oturumu bütün sırları sızdırabilir ya da yedekleri başka yere yönlendirebilirdi.',
  'adminOps.search': 'Ara',
  'adminOps.more': 'Daha eski kayıtlar',
  'adminOps.empty': 'Kayıt yok.',
  'adminOps.refresh': 'Yenile',
  'adminOps.mail.test': 'Test e-postası gönder',
  'adminOps.mail.accepted': '{relay} kabul etti → {to}. Gelen kutunu ve spam klasörünü kontrol et.',
  'adminOps.mail.localRelay': 'Bu sunucudaki yerel aktarıcı ({relay}) kabul etti; ama gerçekten teslim edildiği doğrulanamıyor (bu sunucudan giden posta portları kapalı). SMTP_URL bir dış sağlayıcıyı (ör. Resend) göstermeli.',
  'adminOps.mail.failed': 'Gönderilemedi ({error}). Sunucudaki SMTP ayarını kontrol et.',
  'adminOps.audit.action': 'İşlem (önek)',
  'adminOps.audit.actor': 'Kim (kullanıcı adı)',
  'adminOps.audit.resourceType': 'Kaynak türü',
  'adminOps.audit.before': 'Önce',
  'adminOps.audit.after': 'Sonra',
  'adminOps.security.summary': 'Son 7 gün',
  'adminOps.security.counts': '24 sa: {d1} · 7 gün: {d7}',
  'adminOps.ai.period': 'Dönem',
  'adminOps.ai.days': { one: '{count} gün', other: '{count} gün' },
  'adminOps.ai.provider': 'Sağlayıcı',
  'adminOps.ai.off': 'Kapalı (ANTHROPIC_API_KEY yok)',
  'adminOps.ai.safety': 'AI öğretmen güvenlik yanıtı: {count} (içerik saklanmaz)',
  'adminOps.ai.line': '{requests} istek · {ok} başarılı · {refused} reddedildi · {errors} hata · {users} kişi · {tokens} token · ort. {latency} ms',
  'adminOps.ai.daily': 'Günlük istek',
  'adminOps.ai.topUsers': 'En çok kullananlar',
  'adminOps.ai.privacy': 'Yalnız sayılar tutulur; hiçbir AI isteğinin metni saklanmaz.',
  'adminOps.state.ok': 'çalışıyor',
  'adminOps.state.degraded': 'kısıtlı',
  'adminOps.state.fail': 'hata',
  'adminOps.state.off': 'kapalı',
  'adminOps.system.release': 'Sürüm: {release} · Node {node}',
  'adminOps.system.process': 'Çalışma süresi: {uptime} dk · bellek {memory} MB',
  'adminOps.system.migrations': 'Veritabanı geçişleri: {count} · son: {latest}',
  'adminOps.system.outbox': 'Bekleyen olay: {pending} · en eskisi {oldest} sn',
  'adminOps.system.db': 'Veritabanı boyutu: {size} MB',
  'adminOps.system.counts': 'Kullanıcı: {users} · son 24 sa yeni: {newUsers} · mesaj: {messages} · bu sunucudaki canlı bağlantı: {sockets}',
  'adminOps.system.note': 'Yedekleme ve dış izleme sunucudaki zamanlayıcılarla çalışır; durumları bu sürümde panelde gösterilmiyor.',
  'settings.section.account': 'Hesap',
  'settings.section.account.desc': 'Profilin ve oturumun',
  'settings.section.appearance': 'Görünüm',
  'settings.section.appearance.desc': 'Tema ve dil',
  'settings.section.privacy': 'Gizlilik',
  'settings.section.privacy.desc': 'Seni kim görebilir, kim yazabilir',
  'settings.section.notifications': 'Bildirimler',
  'settings.section.notifications.desc': 'Anlık bildirimler ve önizleme',
  'settings.section.security': 'Güvenlik',
  'settings.section.security.desc': 'Passkey ve uçtan uca şifreleme',
  'settings.section.devices': 'Cihazlar',
  'settings.section.devices.desc': 'Oturum açık cihazların',
  'settings.theme': 'Tema',
  'settings.account.details': 'Hesap bilgileri',
  'settings.account.email': 'E-posta',
  'settings.account.verified': 'Doğrulandı',
  'settings.account.unverified': 'Doğrulanmadı',
  'settings.account.type': 'Hesap türü',
  'settings.account.adult': 'Yetişkin',
  'settings.account.minor': '18 yaş altı (korumalı)',
  'settings.account.since': 'Üyelik tarihi',
  'settings.account.session': 'Oturum',
  'settings.account.sessionHint': 'Bu cihazdan çıkış yapar. Diğer cihazlarını Cihazlar bölümünden yönetebilirsin.',
  'e2ee.deviceUnverifiedShort': 'şifreli sohbetler için gerekli',
  'e2ee.fix': 'Çöz',
  'e2ee.later': 'Daha sonra',
  'e2ee.openSecurity': 'Güvenlik ayarları',
  'e2ee.singleDeviceHint': 'Başka cihazın yoksa ve kurtarma anahtarını kaydetmediysen: Ayarlar → Güvenlik → "Şifreleme kimliğini sıfırla". Henüz şifreli sohbetin yoksa bir şey kaybetmezsin.',
  'chat.splashTitle': '{brand} Web',
  'chat.splashFoot': 'Mesajların sunucuya şifreli bağlantıyla iletilir; istersen sohbet bazında uçtan uca şifreleme açabilirsin.',
  'chat.newDesc': 'Bir kişiyi kullanıcı adıyla ekle ya da yeni bir grup kur.',
  'e2ee.fix.otherTitle': 'Diğer cihazından onayla',
  'e2ee.fix.otherBody': 'DijitalApp\'in açık olduğu diğer cihazında gelen isteği kabul et ve iki ekrandaki emojilerin aynı olduğunu onayla.',
  'e2ee.fix.waiting': 'Diğer cihazın onayı bekleniyor…',
  'e2ee.fix.resetTitle': 'Bu cihazda şifrelemeyi yeniden kur',
  'e2ee.fix.resetBody': 'Hesabında başka açık cihaz yok. Şifreni girmen yeterli: bu cihaz doğrulanır ve sana yeni bir kurtarma anahtarı verilir (bir yere kaydet). Eski şifreli mesajlar yalnız eski kurtarma anahtarıyla okunabilir.',
  'e2ee.fix.resetAction': 'Yeniden kur',
  'e2ee.fix.recoveryTitle': 'Kurtarma anahtarıyla doğrula',
  'e2ee.fix.haveRecovery': 'Kurtarma anahtarım var',
  'e2ee.fix.noAccess': 'Diğer cihazıma erişemiyorum',
  'e2ee.fix.resetBodyOther': 'Diğer cihazına ulaşamıyorsan şifreni girmen yeterli: bu cihaz doğrulanır ve sana yeni bir kurtarma anahtarı verilir (bir yere kaydet). Eski şifreli mesajlar yalnız eski kurtarma anahtarıyla okunabilir.',
} satisfies Record<string, Entry>;

export type MessageKey = keyof typeof tr;

export const en: Record<MessageKey, Entry> = {
  'app.loading': 'Loading…',
  'nav.messages': 'Messages',
  'nav.calls': 'Calls',
  'nav.spaces': 'Spaces',
  'nav.discover': 'Discover',
  'nav.ai': 'AI',
  'nav.settings': 'Settings',
  'auth.login.title': 'Sign in',
  'auth.register.title': 'Create account',
  'auth.identifier': 'Email or username',
  'auth.email': 'Email',
  'auth.username': 'Username',
  'auth.password': 'Password',
  'auth.passwordHint': 'At least 10 characters',
  'auth.displayName': 'Display name',
  'auth.birthDate': 'Date of birth',
  'auth.birthDateHint': 'Used to apply age-appropriate safety settings; never shown on your profile.',
  'auth.country': 'Country',
  'auth.acceptTerms': 'I have read and accept the terms of use and the privacy notice.',
  'auth.submitLogin': 'Sign in',
  'auth.submitRegister': 'Create account',
  'auth.noAccount': 'No account yet?',
  'auth.haveAccount': 'Already have an account?',
  'auth.logout': 'Sign out',
  'auth.or': 'or',
  'auth.forgotLink': 'Forgot password',
  'auth.forgot.title': 'Reset your password',
  'auth.forgot.body': 'Enter your account email. If an account exists we will send a reset link.',
  'auth.forgot.submit': 'Send link',
  'auth.forgot.sent': 'If an account is registered to this address, a reset link has been sent. It is valid for 30 minutes.',
  'auth.reset.title': 'Choose a new password',
  'auth.reset.newPassword': 'New password',
  'auth.reset.submit': 'Change password',
  'auth.reset.done': 'Your password was changed and all sessions were signed out. Sign in with your new password.',
  'auth.verify.title': 'Email verification',
  'auth.verify.working': 'Verifying…',
  'auth.verify.success': 'Your email address is verified.',
  'auth.verify.continue': 'Back to the app',
  'auth.passkey.login': 'Sign in with a passkey',
  'auth.passkey.unsupported': 'This browser does not support passkeys.',
  'auth.passkey.cancelled': 'The passkey request was cancelled.',
  'banner.emailUnverified': 'Verify your email address: {email}',
  'banner.resend': 'Resend link',
  'banner.resent': 'Verification link sent.',
  'passkeys.title': 'Passkeys',
  'passkeys.body': 'Sign in with your device lock (fingerprint, face, PIN) instead of a password.',
  'passkeys.add': 'Add a passkey',
  'passkeys.empty': 'You have not added a passkey yet.',
  'passkeys.created': 'Added: {date}',
  'passkeys.lastUsed': 'Last used: {date}',
  'passkeys.remove': 'Remove',
  'passkeys.added': 'Passkey added.',
  'passkeys.synced': 'Synced',
  'mail.verify.subject': '{brand}: verify your email address',
  'mail.verify.body': 'Hi {name},\n\nUse the link below to verify the email address of your {brand} account. The link is valid for 24 hours.',
  'mail.verify.cta': 'Verify my email',
  'mail.reset.subject': '{brand}: password reset',
  'mail.reset.body': 'Hi {name},\n\nUse the link below to reset your password. It is valid for 30 minutes and can be used once. If you did not request this, ignore this email; your password will not change.',
  'mail.reset.cta': 'Reset my password',
  'mail.passwordChanged.subject': '{brand}: your password was changed',
  'mail.passwordChanged.body': 'Hi {name},\n\nThe password of your {brand} account was just changed and all sessions were signed out. If this was not you, contact support immediately.',
  'mail.passwordChanged.cta': 'Sign in',
  'mail.test.subject': '{brand}: test email',
  'mail.test.body': 'Hi {name},\n\nThis is a test email sent from the {brand} admin console. If you can read it, email delivery works.',
  'mail.test.cta': 'Open the console',
  'mail.footer': 'This email was sent automatically because of an action on your {brand} account.',
  'chat.title': 'Chats',
  'chat.search': 'Search chats',
  'chat.new': 'New chat',
  'chat.empty': 'No chats yet. Add someone by @username under Contacts and start a chat.',
  'chat.select': 'Select a chat',
  'chat.selectBody': 'Pick a chat from the list or start a new one.',
  'chat.placeholder': 'Write a message',
  'chat.send': 'Send',
  'chat.typing': '{name} is typing…',
  'chat.loadOlder': 'Load earlier messages',
  'chat.today': 'Today',
  'chat.yesterday': 'Yesterday',
  'chat.you': 'You',
  'chat.noMessages': 'No messages yet. Say hello.',
  'chat.status.queued': 'Waiting to send',
  'chat.status.sending': 'Sending',
  'chat.status.sent': 'Sent',
  'chat.status.delivered': 'Delivered',
  'chat.status.read': 'Read',
  'chat.status.failed': 'Not sent',
  'chat.retry': 'Retry',
  'chat.discard': 'Delete',
  'chat.cannotSend': 'You cannot message this person right now.',
  'chat.waitForReply': 'You can reply once this person adds you to their contacts or writes to you.',
  'chat.verifyToSend': 'Verify your email address to send messages.',
  'chat.restrictedToSend': 'Messaging opens once a parent/guardian has approved.',
  'chat.encryptionNotice': 'Messages travel to the server over an encrypted connection (TLS) and are stored there. End-to-end encryption is not available yet.',
  'chat.unread': { one: '{count} unread message', other: '{count} unread messages' },
  'chat.back': 'Back to chats',
  'contacts.title': 'Contacts',
  'contacts.add': 'Add',
  'contacts.addLabel': 'Add a contact by username',
  'contacts.usernamePlaceholder': '@username',
  'contacts.added': '{name} added to your contacts.',
  'contacts.empty': 'No contacts yet.',
  'contacts.message': 'Message',
  'contacts.block': 'Block',
  'contacts.unblock': 'Unblock',
  'contacts.blocked': 'Blocked',
  'contacts.hint': 'Adding someone lets them message you. To message them, they need to add you too or accept messages from everyone.',
  'push.newMessage': 'New message',
  'push.newMessageHidden': 'You have a new message',
  'notifications.title': 'Notifications',
  'notifications.body': 'Hear about new messages while the app is closed.',
  'notifications.enable': 'Turn on notifications on this device',
  'notifications.disable': 'Turn off on this device',
  'notifications.enabled': 'Notifications are on for this device.',
  'notifications.denied': 'The browser blocked notifications. You can allow them in the site settings.',
  'notifications.unsupported': 'This browser does not support web notifications.',
  'notifications.unavailable': 'Notifications are not available right now.',
  'notifications.preview': 'Show in notifications',
  'notifications.preview.full': 'Sender and message',
  'notifications.preview.sender': 'Sender only',
  'notifications.preview.hidden': 'No details',
  'notifications.previewHint': 'Message text is sent encrypted to the push service but may appear on your lock screen.',
  'mute.label': 'Mute',
  'mute.1h': '1 hour',
  'mute.8h': '8 hours',
  'mute.1w': '1 week',
  'mute.forever': 'Always',
  'mute.off': 'Unmute',
  'mute.active': 'Muted',
  'report.message': 'Report',
  'report.user': 'Report user',
  'report.title': 'Report',
  'report.reason': 'Why are you reporting this?',
  'report.reason.spam': 'Spam or unwanted messages',
  'report.reason.harassment': 'Harassment or bullying',
  'report.reason.hate': 'Hate speech',
  'report.reason.sexual_content': 'Sexual content',
  'report.reason.child_safety': 'A child’s safety is at risk',
  'report.reason.self_harm': 'Self-harm',
  'report.reason.violence': 'Violence or threats',
  'report.reason.impersonation': 'Impersonation',
  'report.reason.scam': 'Scam or fraud',
  'report.reason.other': 'Something else',
  'report.details': 'Anything else we should know (optional)',
  'report.includeRecent': { one: 'Include the last {count} message as evidence', other: 'Include the last {count} messages as evidence' },
  'report.evidenceNote': 'Only the reported message and the messages you choose to include are shared with the review team.',
  'report.alsoBlock': 'Block this person',
  'report.submit': 'Send report',
  'report.sent': 'Thank you. Your report was received and will be reviewed.',
  'report.emergency': 'If someone is in immediate danger, call your local emergency number now.',
  'common.close': 'Close',
  'admin.nav': 'Admin',
  'admin.title': 'Administration',
  'admin.passkeyRequired': 'Admin actions only work in a passkey session less than 12 hours old. Sign out and sign in again with “Sign in with a passkey”.',
  'admin.roles': 'Your roles: {roles}',
  'admin.tab.users': 'Users',
  'admin.tab.reports': 'Reports',
  'admin.tab.invites': 'Invites',
  'admin.search': 'Username, email or id',
  'admin.state.active': 'Active',
  'admin.state.restricted': 'Restricted',
  'admin.state.suspended': 'Suspended',
  'admin.suspend': 'Suspend',
  'admin.unsuspend': 'Unsuspend',
  'admin.suspendReason': 'Reason for suspension (recorded)',
  'admin.noResults': 'No results.',
  'admin.reports.empty': 'No pending reports.',
  'admin.reports.priority': 'Priority {priority}',
  'admin.reports.evidence': 'Evidence',
  'admin.reports.note': 'Decision note (recorded)',
  'admin.reports.action': 'Action taken',
  'admin.reports.dismiss': 'Dismiss',
  'admin.invites.create': 'Create codes',
  'admin.invites.count': 'Count',
  'admin.invites.note': 'Note',
  'admin.invites.newCodes': 'New codes (shown only now):',
  'admin.invites.used': '{used}/{max} used',
  'admin.invites.revoke': 'Revoke',
  'admin.invites.revoked': 'Revoked',
  'conn.connected': 'Connected',
  'conn.reconnecting': 'Reconnecting…',
  'onboarding.title': 'How will you use DijitalApp?',
  'onboarding.subtitle': 'We tailor your home screen to it. You can change this any time.',
  'onboarding.continue': 'Continue',
  'onboarding.skip': 'Skip for now',
  'onboarding.personaNote': 'A mode only changes what you see; it never grants permissions or roles.',
  'shell.activeSpace': 'Active space',
  'shell.minorNotice': 'Your account uses protected settings appropriate for your age.',
  'shell.guardianPending': 'Some features stay off until a parent/guardian approves.',
  'module.disabled.title': 'This section is not open yet',
  'module.disabled.body': '{module} is under development and currently disabled. It will appear here when ready.',
  'spaces.title': 'My spaces',
  'spaces.create': 'New space',
  'spaces.name': 'Space name',
  'spaces.type': 'Space type',
  'spaces.members': { one: '{count} member', other: '{count} members' },
  'spaces.type.personal': 'Personal',
  'spaces.type.family': 'Family',
  'spaces.type.community': 'Community',
  'spaces.type.school': 'Education',
  'spaces.type.business': 'Business',
  'spaces.type.event': 'Event',
  'spaces.verificationRequired': 'Education and business spaces require organization verification.',
  'spaces.persona': 'Mode in this space',
  'settings.title': 'Settings',
  'settings.devices': 'Devices',
  'settings.privacy': 'Privacy',
  'settings.appearance': 'Appearance',
  'settings.theme.light': 'Light',
  'settings.theme.dark': 'Dark',
  'settings.theme.system': 'System',
  'settings.language': 'Language',
  'devices.current': 'This device',
  'devices.lastActive': 'Last active: {date}',
  'devices.firstSeen': 'First sign-in: {date}',
  'devices.signOut': 'Sign out',
  'devices.signOutOthers': 'Sign out of all other devices',
  'devices.count': { one: '{count} active device', other: '{count} active devices' },
  'privacy.lockedByAge': 'Locked by age policy',
  'privacy.saved': 'Privacy settings saved',
  'privacy.profileDiscoverable': 'Let people find my profile in search',
  'privacy.dmFromNonContacts': 'Allow messages from people not in my contacts',
  'privacy.lastSeen': 'Last seen',
  'privacy.readReceipts': 'Read receipts',
  'privacy.phoneVisible': 'Show my phone number',
  'privacy.audience.everyone': 'Everyone',
  'privacy.audience.contacts': 'My contacts',
  'privacy.audience.nobody': 'Nobody',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.retry': 'Retry',
  'common.on': 'On',
  'common.off': 'Off',
  'conn.offline': 'Offline',
  'conn.connecting': 'Connecting…',
  'error.AUTH_INVALID_CREDENTIALS': 'Incorrect email/username or password.',
  'error.AUTH_SESSION_EXPIRED': 'Your session has expired. Please sign in again.',
  'error.AUTH_REQUIRED': 'Please sign in to continue.',
  'error.AUTH_ORIGIN_REJECTED': 'The request failed a security check. Reload the page and try again.',
  'error.AGE_BELOW_MINIMUM': 'Sorry, a DijitalApp account cannot be created at this age in your country.',
  'error.EMAIL_TAKEN': 'An account with this email already exists.',
  'error.USERNAME_TAKEN': 'This username is not available.',
  'error.USERNAME_RESERVED': 'This username is reserved; please choose another.',
  'error.VALIDATION_FAILED': 'Please check the information you entered.',
  'error.RATE_LIMITED': 'Too many attempts. Please wait a moment and try again.',
  'error.FORBIDDEN': 'You are not allowed to do this.',
  'error.NOT_FOUND': 'We could not find what you were looking for.',
  'error.POLICY_LOCKED': 'This setting cannot be changed because of your age-appropriate safety policy.',
  'error.SPACE_VERIFICATION_REQUIRED': 'This space type requires organization verification.',
  'error.TERMS_NOT_ACCEPTED': 'You need to accept the terms to continue.',
  'error.ENTITLEMENT_LIMIT': 'You have reached your plan limit.',
  'error.EMAIL_TOKEN_INVALID': 'This link is invalid, already used or expired. Request a new one.',
  'error.PASSKEY_FAILED': 'The passkey could not be verified. Please try again.',
  'error.EMAIL_NOT_VERIFIED': 'Verify your email address first.',
  'error.MESSAGING_NOT_ALLOWED': 'You cannot message this person right now.',
  'error.MESSAGE_TOO_LARGE': 'The message is too long.',
  'error.AUTH_TICKET_INVALID': 'Could not open the live connection. Retrying.',
  'error.PROTOCOL_INVALID_FRAME': 'Something went wrong talking to the server.',
  'error.REGISTRATION_CLOSED': 'New sign-ups are closed right now.',
  'error.INVITE_INVALID': 'This invite code is invalid, already used or expired.',
  'error.ADMIN_PASSKEY_REQUIRED': 'Admin actions require a passkey sign-in within the last 12 hours.',
  'error.MESSAGE_EDIT_EXPIRED': 'The time to edit or delete this message has passed.',
  'error.ATTACHMENT_REJECTED': 'This file type is not supported or the file is damaged.',
  'error.STORAGE_QUOTA_EXCEEDED': 'Your storage is full. Delete old files to free up space.',
  'push.photo': '📷 Photo',
  'push.voice': '🎤 Voice message',
  'push.file': '📎 File',
  'push.video': '🎬 Video',
  'error.PIN_LIMIT': 'At most 3 messages can be pinned. Unpin one first.',
  'chat.reply': 'Reply',
  'chat.replyingTo': 'Replying to {name}',
  'chat.originalMessage': 'An earlier message',
  'chat.forward': 'Forward',
  'chat.forwarded': 'Forwarded',
  'chat.forwardTitle': 'Forward message',
  'chat.forwardHint': 'You can pick up to 5 chats.',
  'chat.forwardSent': 'Forwarded.',
  'chat.forwardPartial': 'Could not forward to {count} chats.',
  'chat.pin': 'Pin',
  'chat.unpin': 'Unpin',
  'chat.pinned': 'Pinned message',
  'chat.react': 'React',
  'chat.reactionsBy': '{emoji}: {names}',
  'chat.attachmentLabel': 'Attachment',
  'error.AI_UNAVAILABLE': 'The writing assistant is not available right now.',
  'error.AI_CONSENT_REQUIRED': 'Please agree before using the writing assistant.',
  'error.AI_QUOTA_EXCEEDED': 'You have used today\'s writing assistant allowance. It resets tomorrow.',
  'error.AI_REFUSED': 'The writing assistant did not edit this text.',
  'tpl.title': 'Templates',
  'tpl.open': 'Insert template',
  'tpl.search': 'Search templates',
  'tpl.empty': 'No templates found.',
  'tpl.mine': 'Mine',
  'tpl.category.general': 'General',
  'tpl.category.education': 'Education',
  'tpl.category.work': 'Work',
  'tpl.category.social': 'Social',
  'tpl.saveDraft': 'Save draft as template',
  'tpl.namePrompt': 'Template name',
  'tpl.delete': 'Delete',
  'tpl.hint': 'Fill in the bracketed parts (like [date]) before sending.',
  'ai.open': 'Writing assistant',
  'ai.title': 'Writing assistant',
  'ai.action.fix': 'Fix spelling',
  'ai.action.shorten': 'Shorten',
  'ai.action.formal': 'Make formal',
  'ai.action.friendly': 'Make friendly',
  'ai.action.translate_en': 'Translate to English',
  'ai.action.translate_tr': 'Translate to Turkish',
  'ai.consentTitle': 'About the writing assistant',
  'ai.consentBody': 'When you use the assistant, only the draft you are writing is sent to the AI provider ({provider}); your chat history and other people\'s messages are not. Email addresses, phone, IBAN, national id and card numbers are hidden before sending and put back in the result. DijitalApp does not store the text; it only counts how often you use the assistant. The provider\'s use of data is governed by its commercial terms. Nothing is sent to the chat until you accept a suggestion. You can withdraw consent at any time on the AI page.',
  'ai.consentAccept': 'I understand, turn it on',
  'ai.consentWithdraw': 'Withdraw consent',
  'ai.e2eeWarning': 'This chat is end-to-end encrypted. Using the assistant sends this draft outside the encryption, to the provider.',
  'ai.suggestion': 'Suggestion',
  'ai.use': 'Apply to draft',
  'ai.redacted': '{count} personal details were hidden from the provider.',
  'ai.missing': '{count} hidden details are missing from the suggestion; please check the text.',
  'ai.remaining': 'Left today: {count}',
  'ai.working': 'Working…',
  'ai.notForAccount': 'The writing assistant is not available for accounts under 18.',
  'ai.unavailable': 'The writing assistant is not enabled on this server yet.',
  'ai.pageIntro': 'The writing assistant fixes, shortens, changes the tone of, or translates your message drafts. Only your draft is sent, and only when you ask.',
  'ai.consentGiven': 'Consent given.',
  'ai.noConsent': 'You have not agreed yet.',
  'call.voice': 'Voice call',
  'call.video': 'Video call',
  'call.incomingVoice': '{name} is calling…',
  'call.incomingVideo': '{name} is video calling…',
  'call.calling': 'Calling {name}…',
  'call.connecting': 'Connecting…',
  'call.accept': 'Answer',
  'call.acceptAudio': 'Answer with audio',
  'call.decline': 'Decline',
  'call.hangup': 'Hang up',
  'call.mute': 'Mute',
  'call.unmute': 'Unmute',
  'call.cameraOff': 'Turn camera off',
  'call.cameraOn': 'Turn camera on',
  'call.ended.hangup': 'Call ended.',
  'call.ended.rejected': 'Call declined.',
  'call.ended.missed': 'No answer.',
  'call.ended.busy': 'They are on another call.',
  'call.ended.cancelled': 'Call cancelled.',
  'call.ended.failed': 'Could not connect.',
  'call.ended.disconnected': 'Connection lost.',
  'call.ended.answered_elsewhere': 'Answered on another device.',
  'call.permissionDenied': 'Microphone/camera access was not granted. You can allow it in the browser settings.',
  'call.encryptedNote': 'Encrypted connection (DTLS-SRTP). Media is relayed by the server; the other side does not see your IP address.',
  'call.history': 'Calls',
  'call.noHistory': 'No calls yet.',
  'call.incoming': 'Incoming',
  'call.outgoing': 'Outgoing',
  'call.missedLabel': 'Missed',
  'call.duration': '{minutes} min {seconds} s',
  'call.unsupported': 'This browser does not support calls.',
  'push.call': '📞 Incoming call',
  'call.ended.permission': 'Microphone/camera access was not granted.',
  'call.ended.unsupported': 'This browser does not support calls.',
  'call.ended.not_allowed': 'You cannot call this person (block or message settings).',
  'push.videoCall': '🎥 Incoming video call',
  'error.E2EE_IDENTITY_CHANGED': 'Someone you verified changed their encryption identity. Verify them again or accept the change (warning in the chat header) before sending.',
  'e2ee.fileFailed': '🔒 The file could not be opened on this device (no key, or the file was altered).',
  'e2ee.unverifiedSender': 'The sending device could not be verified (restored from backup).',
  'e2ee.trust.verified': 'Verified',
  'e2ee.trust.unverified': 'Not verified',
  'e2ee.trust.changed': 'Identity changed',
  'e2ee.verifyTitle': 'Verify {name}',
  'e2ee.verifyIntro': 'Verifying makes sure your messages really go to the devices of {name}. Do it in person or on a video call.',
  'e2ee.verifyEmoji': 'Verify with emoji',
  'e2ee.verifyEmojiHint': 'Both of you need DijitalApp open. When they accept, the same emoji appear on both screens.',
  'e2ee.safetyCode': 'Verify with a safety code',
  'e2ee.theirCode': 'Code of {name}',
  'e2ee.yourCode': 'Your code',
  'e2ee.codeHint': 'Ask them to compare "Your code" under Settings → End-to-end encryption with "Code of {name}" here. Verify only if they are identical.',
  'e2ee.codesMatch': 'The codes match, verify',
  'e2ee.noIdentity': 'This person has not set up encryption yet.',
  'e2ee.requestIncoming': '{name} wants to verify with you.',
  'e2ee.requestIncomingSelf': 'Your other device wants to verify this device.',
  'e2ee.accept': 'Accept',
  'e2ee.decline': 'Decline',
  'e2ee.waitingAccept': 'Waiting for the other side to accept…',
  'e2ee.emojiHint': 'Do the same emoji appear in the same order on both screens?',
  'e2ee.match': 'Yes, they match',
  'e2ee.noMatch': 'No, they differ',
  'e2ee.waitingOther': 'Waiting for the other side to confirm…',
  'e2ee.done': 'Verification complete ✓',
  'e2ee.cancelled': 'Verification was cancelled.',
  'e2ee.changedTitle': '{name} changed their security identity',
  'e2ee.changedBody': 'They may have set up a new device or reset their encryption identity; messages could also be going to someone else. Verify again to be sure. If you accept without verifying, messages go to the new identity.',
  'e2ee.acceptChange': 'Accept without verifying',
  'e2ee.reverify': 'Verify again',
  'e2ee.deviceUnverifiedTitle': 'This device is not verified yet',
  'e2ee.deviceUnverifiedBody': 'To read and write encrypted chats here, verify this device with your other device (emoji). You can also enter your recovery key for earlier messages.',
  'e2ee.verifyThisDevice': 'Verify with my other device',
  'e2ee.enterRecovery': 'Recovery key',
  'e2ee.restore': 'Restore history',
  'e2ee.restored': '{count} chat keys restored.',
  'e2ee.wrongRecovery': 'This recovery key does not match the backup.',
  'e2ee.resetTitle': 'Reset encryption identity',
  'e2ee.resetBody': 'Only if you lost all your devices. A new encryption identity and a new recovery key are created; your contacts see an "identity changed" warning and need to verify you again. Old messages stay readable only with the old recovery key.',
  'e2ee.reset': 'Reset identity',
  'e2ee.recoveryTitle': 'Your recovery key',
  'e2ee.recoveryBody': 'If you lose all your devices, this key is the only way to bring back your encrypted message history. Keep it in a password manager or on paper and never share it. DijitalApp cannot see this key and cannot recover it for you.',
  'e2ee.saved': 'I saved it',
  'e2ee.settingsTitle': 'End-to-end encryption',
  'e2ee.thisDevice': 'This device',
  'e2ee.showRecovery': 'Show recovery key',
  'e2ee.notOnThisDevice': 'Not on this device; it arrives when you verify with your other device.',
  'e2ee.loading': 'Setting up encryption…',
  'error.E2EE_REQUIRED': 'This chat is end-to-end encrypted; messages cannot be sent unencrypted.',
  'error.E2EE_UNAVAILABLE': 'Everyone in the chat needs encryption set up (DijitalApp opened) on at least one device first.',
  'error.E2EE_UNSUPPORTED': 'This feature is not available in end-to-end encrypted chats yet.',
  'push.encrypted': '🔒 Encrypted message',
  'e2ee.label': 'End-to-end encrypted (experimental)',
  'e2ee.enable': 'Turn on end-to-end encryption',
  'e2ee.enableConfirm': 'End-to-end encryption will be turned on for this chat. This cannot be undone. Encrypted chats do not support attachments, link previews, editing, reactions or forwarding yet, and a new device cannot read earlier encrypted messages. Continue?',
  'e2ee.notice': 'New messages in this chat are end-to-end encrypted: nobody, not even the DijitalApp server, can read them. Experimental: device verification is not available yet.',
  'e2ee.cannotDecrypt': '🔒 This message cannot be decrypted on this device (the device may have been added after it was sent).',
  'e2ee.decrypting': '🔒 Decrypting…',
  'e2ee.encryptedBadge': 'Encrypted',
  'e2ee.notReady': 'Encryption is still being set up on this device; try again in a few seconds.',
  'e2ee.unsupportedBrowser': 'This browser does not support end-to-end encryption.',
  'chat.star': 'Star',
  'chat.unstar': 'Unstar',
  'chat.starred': 'Starred messages',
  'chat.noStarred': 'No starred messages yet. Choose "Star" in a message\'s options to keep it here.',
  'chat.openInChat': 'Show in chat',
  'chat.info': 'Info',
  'chat.infoTitle': 'Message info',
  'chat.readBy': 'Read',
  'chat.deliveredTo': 'Delivered',
  'chat.pendingTo': 'Not delivered yet',
  'chat.readsHidden': 'Read status is hidden because you turned off read receipts.',
  'chat.previewLoading': 'Preparing link preview…',
  'chat.removePreview': 'Remove preview',
  'error.ATTACHMENT_MALWARE': 'Malware was found in this file; it was not sent.',
  'error.ATTACHMENT_SCAN_UNAVAILABLE': 'Files cannot be security-scanned right now. Try again shortly.',
  'chat.attach': 'Attach a file',
  'chat.record': 'Record a voice message',
  'chat.stopRecording': 'Stop and send',
  'chat.cancelRecording': 'Cancel recording',
  'chat.recording': 'Recording… {seconds} s',
  'chat.uploading': 'Uploading…',
  'chat.download': 'Download',
  'chat.micDenied': 'Microphone access was not granted. You can allow it in the browser settings.',
  'chat.voiceMessage': 'Voice message',
  'chat.tooLarge': 'The file is too large (up to {mb} MB).',
  'chat.searchMessages': 'Messages',
  'group.new': 'New group',
  'group.title': 'Group name',
  'group.description': 'Description',
  'group.pickMembers': 'Pick members from your contacts (you can add more later):',
  'group.addHint': 'People are added only if their privacy setting allows it (default: only people they added).',
  'group.create': 'Create group',
  'group.info': 'Group info',
  'group.memberCount': { one: '{count} member', other: '{count} members' },
  'group.someoneTyping': 'Someone is typing…',
  'group.onlyAdmins': 'Only admins can send messages (announcement mode)',
  'group.role.owner': 'Owner',
  'group.role.admin': 'Admin',
  'group.makeAdmin': 'Make admin',
  'group.makeMember': 'Remove admin',
  'group.remove': 'Remove',
  'group.addMembers': 'Add members',
  'group.add': 'Add',
  'group.leave': 'Leave group',
  'group.leaveConfirm': 'Leave this group?',
  'group.skipped': 'These people could not be added because of their privacy settings: {names}',
  'error.SPACE_LINK_INVALID': 'This invite link is invalid or has expired.',
  'error.GROUP_LINK_INVALID': 'This group link is invalid, revoked or expired.',
  'error.GROUP_FULL': 'The group has reached its member limit.',
  'group.inviteLink': 'Invite link',
  'group.linkHint': 'Anyone with the link can join or ask to join. Share it only with people you trust.',
  'group.noLink': 'No active link.',
  'group.createLink': 'Create link',
  'group.resetLink': 'Create a new link (the old one stops working)',
  'group.revokeLink': 'Revoke link',
  'group.requireApproval': 'Require admin approval to join',
  'group.linkExpiry': 'Valid for',
  'group.expiry.never': 'Until revoked',
  'group.expiry.24': '1 day',
  'group.expiry.168': '1 week',
  'group.expiry.720': '30 days',
  'group.linkActive': 'Active link: created {date} · used {uses} times',
  'group.linkExpires': 'Expires: {date}',
  'group.linkOnce': 'The link is shown only now; it is not stored for security. Create a new one if you lose it.',
  'group.copyLink': 'Copy',
  'group.linkCopied': 'Copied',
  'group.joinRequests': 'Join requests',
  'group.noRequests': 'No pending requests.',
  'group.approve': 'Approve',
  'group.reject': 'Decline',
  'group.previouslyRemoved': 'removed before',
  'group.pendingBadge': '{count} requests',
  'join.title': 'Join group',
  'join.join': 'Join',
  'join.request': 'Ask to join',
  'join.requested': 'Request sent. The group will appear in your chats once an admin approves it.',
  'join.approvalNote': 'An admin must approve new members of this group.',
  'join.open': 'Open chat',
  'join.missingToken': 'This link has no invite in it.',
  'join.privacyNote': 'When you join, group members can see your name and username.',
  'privacy.groupAdd': 'Who can add me to groups',
  'chat.online': 'online',
  'chat.lastSeen': 'last seen {date}',
  'chat.edit': 'Edit',
  'chat.edited': 'edited',
  'chat.editing': 'Editing message',
  'chat.save': 'Save',
  'chat.deleteForMe': 'Delete for me',
  'chat.deleteForEveryone': 'Delete for everyone',
  'chat.deleted': 'This message was deleted',
  'chat.messageActions': 'Message options',
  'auth.inviteCode': 'Invite code',
  'auth.inviteHint': 'DijitalApp is in an invite-only closed beta.',
  'auth.registrationClosed': 'New sign-ups are closed right now. If you have an account, sign in.',
  'error.NETWORK': 'Cannot reach the server. Check your connection.',
  'error.UNKNOWN': 'Something unexpected happened. Please try again.',
  'channel.title': 'Channels',
  'channel.intro': 'Channels are one-to-many broadcasts: only admins post, subscribers read and cannot see each other.',
  'channel.mine': 'My channels',
  'channel.none': 'You are not subscribed to any channel yet.',
  'channel.directory': 'Public channels',
  'channel.search': 'Search channels',
  'channel.noResults': 'No channels found.',
  'channel.subscribe': 'Subscribe',
  'channel.subscribers': { one: '{count} subscriber', other: '{count} subscribers' },
  'channel.privacyNote': 'When you subscribe, the channel admins can see you in the subscriber list; other subscribers cannot.',
  'channel.adultsOnly': 'The public channel directory is for adult accounts only. You can join private channels with an invite link.',
  'channel.create': 'Create channel',
  'channel.name': 'Channel name',
  'channel.public': 'Public (listed in the directory)',
  'channel.publicNote': 'Public channels are listed in the directory; adult accounts can find and subscribe to them.',
  'channel.privateNote': 'Private channels are joined only by invite link (create one from the channel info).',
  'channel.subscriberNote': 'This is a channel: only admins can post.',
  'community.title': 'Community',
  'community.announcements': 'Announcements',
  'community.announcementsAdmin': 'Post an announcement to all members',
  'community.announcementsMember': 'Announcements from the admins',
  'community.groups': 'Groups',
  'community.noGroups': 'No groups yet.',
  'community.closed': 'closed',
  'community.newGroup': 'New group name',
  'community.openGroup': 'Open group (community members can join themselves)',
  'community.invite': 'Invite link',
  'community.inviteNote': 'Adults with the link join the community and are subscribed to announcements.',
  'community.inviteFamilyNote': 'Share the link only with your family: minors can join family spaces too.',
  'community.createLink': 'Create a new link (the old one stops working)',
  'community.leave': 'Leave community',
  'community.leaveConfirm': 'Leaving the community also removes you from its announcements and groups. Continue?',
  'community.joinTitle': 'Join community',
  'community.open': 'Open community',
  'community.joinPrivacyNote': 'When you join, the community admins can see your name; group members see you when you join a group.',
  'nav.calendar': 'Calendar',
  'planner.title': 'Calendar and tasks',
  'planner.calendar': 'Calendar',
  'planner.tasks': 'Tasks',
  'planner.personal': 'Personal',
  'planner.prevMonth': 'Previous month',
  'planner.nextMonth': 'Next month',
  'planner.today': 'Today',
  'planner.noEvents': 'No events this month.',
  'planner.allDay': 'All day',
  'planner.cancelled': 'Cancelled',
  'planner.responseCounts': '{going} going · {maybe} maybe · {declined} not going',
  'planner.yourResponse': 'Your response',
  'planner.response.going': 'Going',
  'planner.response.maybe': 'Maybe',
  'planner.response.declined': 'Not going',
  'planner.cancel': 'Cancel event',
  'planner.delete': 'Delete',
  'planner.cancelConfirm': 'Cancel this event for everyone?',
  'planner.deleteConfirm': 'Delete this event?',
  'planner.newEvent': 'New event',
  'planner.eventTitle': 'Event name',
  'planner.where': 'Show it in',
  'planner.date': 'Date',
  'planner.start': 'Starts',
  'planner.end': 'Ends',
  'planner.location': 'Place',
  'planner.description': 'Description',
  'planner.scopeNote': 'Only you see personal items; members of a space or group see its items. End-to-end encrypted groups cannot use the calendar.',
  'planner.addEvent': 'Add event',
  'planner.myTasks': 'My tasks',
  'planner.show': 'Show',
  'planner.showDone': 'Show completed',
  'planner.noTasks': 'No tasks.',
  'planner.assignedTo': 'Assigned to {name}',
  'planner.due': 'Due {date}',
  'planner.deleteTaskConfirm': 'Delete this task?',
  'planner.newTask': 'New task',
  'planner.taskTitle': 'Task',
  'planner.assignee': 'Assignee',
  'planner.unassigned': 'Unassigned',
  'planner.dueDate': 'Due date',
  'planner.addTask': 'Add task',
  'nav.learn': 'Learn',
  'error.EDU_INVITE_INVALID': 'This school invite is invalid, used or expired.',
  'learn.title': 'Learn',
  'learn.classes': 'My classes',
  'learn.teachers': 'Teacher: {names}',
  'learn.studentCount': { one: '{count} student', other: '{count} students' },
  'learn.role.teacher': 'Teacher',
  'learn.role.student': 'Student',
  'learn.role.guardian': 'Guardian',
  'learn.childTitle': '{name} — homework',
  'learn.noClasses': 'no classes',
  'learn.noAssignments': 'No homework.',
  'learn.feedbackLine': 'Teacher: {text}',
  'learn.late': 'Late',
  'learn.status.not_submitted': 'Not handed in',
  'learn.status.missing': 'Missing',
  'learn.status.submitted': 'Handed in',
  'learn.status.returned': 'Returned',
  'learn.guardianNote': 'As a guardian you see homework status, grades and the teacher\'s feedback; you do not see your child\'s answers or messages.',
  'learn.myGuardians': 'My guardians',
  'learn.myGuardiansNote': 'The school linked these people as your guardians. They can see your homework status and grades, not your answers or messages.',
  'learn.empty': 'No classes yet. Ask your teacher for a class link or open your school invite.',
  'learn.request.title': 'Add your school',
  'learn.request.note': 'Only the DijitalApp team opens school spaces: they review your request and verify the institution. Once approved, you run the school.',
  'learn.request.schoolName': 'School name',
  'learn.request.city': 'City',
  'learn.request.message': 'Note (your role, contact)',
  'learn.request.submit': 'Apply',
  'learn.request.pending': 'In review',
  'learn.request.approved': 'Approved',
  'learn.request.rejected': 'Rejected',
  'learn.link': 'Invite link',
  'learn.verified': 'Verified school',
  'learn.people': 'School people',
  'learn.inviteTeacher': 'Create teacher invite',
  'learn.pickStudent': 'Pick a student',
  'learn.inviteGuardian': 'Create guardian invite',
  'learn.teacherLinkNote': 'Single use, valid 7 days, adult accounts only. Give it to the teacher directly.',
  'learn.guardianLinkNote': 'Single use, valid 7 days. Give it directly to the selected student\'s guardian (an adult).',
  'learn.className': 'Class name',
  'learn.subject': 'Subject',
  'learn.createClass': 'Create class',
  'learn.back': 'Back',
  'learn.studentsTitle': { one: '{count} student', other: '{count} students' },
  'learn.noStudents': 'No students yet.',
  'learn.classLink': 'Create class link',
  'learn.classLinkNote': 'Share it only with your students (valid one week). Minors can join only with guardian consent on their account.',
  'learn.newAssignment': 'New homework',
  'learn.assignmentTitle': 'Title',
  'learn.instructions': 'Instructions',
  'learn.assign': 'Assign',
  'learn.assignments': 'Homework',
  'learn.leaveClass': 'Leave class',
  'learn.leaveConfirm': 'Leave this class?',
  'learn.yourAnswer': 'Your answer',
  'learn.submitNote': 'You can edit it until your teacher returns it. Only your teacher sees it.',
  'learn.submit': 'Hand in',
  'learn.resubmit': 'Update',
  'learn.counts': '{submitted}/{students} handed in · {returned} returned',
  'learn.submissions': 'Submissions',
  'learn.deleteAssignmentConfirm': 'Delete this homework?',
  'learn.feedback': 'Feedback',
  'learn.grade': 'Grade',
  'learn.return': 'Return',
  'learn.updateReturn': 'Update',
  'learn.join.title': 'School invite',
  'learn.join.teacher': 'You are joining {school} as a teacher.',
  'learn.join.guardian': 'You are being linked at {school} as the guardian of {name}.',
  'learn.join.class': 'You are joining {school} — {className} as a student.',
  'learn.join.teacherNote': 'Teachers open classes, assign homework and see their students\' submissions.',
  'learn.join.guardianNote': 'You will see your child\'s homework status, grades and the teacher\'s feedback, not their answers or messages. Your child sees you as their guardian.',
  'learn.join.classNote': 'You see your teachers and your own work; classmates do not see you in a class list.',
  'learn.join.accept': 'Accept',
  'admin.tab.schools': 'School requests',
  'admin.schools.note': 'Approval opens a verified school space run by the requester. Do not approve without verifying the institution out of band (official letter, institutional email, phone).',
  'admin.schools.none': 'No pending requests.',
  'admin.schools.reviewNote': 'Review note (shown to the requester)',
  'admin.schools.approve': 'Approve',
  'admin.schools.reject': 'Reject',
  'admin.schools.approveConfirm': 'Is the institution verified? Approval creates a verified school space.',
  'quiz.title': 'Quizzes',
  'quiz.new': 'New quiz',
  'quiz.none': 'No quizzes yet.',
  'quiz.state.draft': 'Draft',
  'quiz.state.published': 'Live',
  'quiz.state.closed': 'Closed',
  'quiz.meta': '{questions} questions · {points} points',
  'quiz.minutes': { one: '{count} min', other: '{count} min' },
  'quiz.stats': '{submitted}/{students} done · avg {average}',
  'quiz.edit': 'Edit',
  'quiz.publish': 'Publish',
  'quiz.publishConfirm': 'Once published, the questions and answer key cannot change. Publish?',
  'quiz.results': 'Results',
  'quiz.close': 'Close',
  'quiz.deleteConfirm': 'Delete this quiz?',
  'quiz.byQuestion': 'By question',
  'quiz.correctRate': '{rate}% correct',
  'quiz.cancel': 'Cancel',
  'quiz.timeLimit': 'Time limit (min)',
  'quiz.showAnswers': 'Correct answers',
  'quiz.policy.after_submit': 'Show right after submitting',
  'quiz.policy.after_close': 'Show when the quiz closes',
  'quiz.policy.never': 'Never show (score only)',
  'quiz.question': 'Question {n}',
  'quiz.prompt': 'Question text',
  'quiz.option': 'Option {n}',
  'quiz.markCorrect': 'Option {n} is correct',
  'quiz.removeOption': 'Remove option {n}',
  'quiz.addOption': 'Add option',
  'quiz.points': 'Points',
  'quiz.removeQuestion': 'Remove question',
  'quiz.correctHint': 'Mark the correct answer of each question with the button on the left. The answer key stays on the server; students cannot see it until the time you choose.',
  'quiz.addQuestion': 'Add question',
  'quiz.saveDraft': 'Save draft',
  'quiz.status.not_started': 'Not started',
  'quiz.status.in_progress': 'In progress',
  'quiz.status.submitted': 'Done',
  'quiz.status.missing': 'Missed',
  'quiz.start': 'Start',
  'quiz.startConfirm': 'The timer does not stop once started: you will have {count} minutes. Start?',
  'quiz.resume': 'Resume',
  'quiz.view': 'See result',
  'quiz.score': 'Score: {score}/{max}',
  'quiz.answersLater': 'Correct answers will be shown when your teacher chose.',
  'quiz.pointsShort': { one: '{count} point', other: '{count} points' },
  'quiz.submit': 'Submit',
  'quiz.blankConfirm': '{count} questions are blank. Submit anyway?',
  'quiz.oneAttempt': 'You have one attempt and cannot change it after submitting. Your answers are submitted automatically when time runs out.',
  'study.title': 'My study plan',
  'study.prevWeek': 'Previous week',
  'study.nextWeek': 'Next week',
  'study.progress': '{done}/{planned} min studied · {blocksDone}/{blocksTotal} blocks',
  'study.weekProgress': 'Weekly progress',
  'study.due': 'Due this week',
  'study.planned': 'Planned',
  'study.auto': 'Plan my week',
  'study.autoCreated': { one: '{count} block added.', other: '{count} blocks added.' },
  'study.autoNothing': 'Nothing new to add.',
  'study.autoNote': 'Suggests a study block the day before each homework or quiz is due, and spreads your goals over the rest of the week. Never in the past; pressing it again adds nothing twice.',
  'study.goals': 'My goals',
  'study.goalLine': '{done}/{target} min this week',
  'study.goalNoTarget': '{done} min this week',
  'study.goalDone': 'Done',
  'study.newGoal': 'New goal',
  'study.goalTitle': 'Goal',
  'study.weeklyMinutes': 'Weekly min',
  'study.addGoal': 'Add goal',
  'study.minutes': { one: '{count} min', other: '{count} min' },
  'study.kind.custom': 'Own',
  'study.kind.homework': 'Homework',
  'study.kind.quiz': 'Quiz',
  'study.kind.goal': 'Goal',
  'study.removeBlock': 'Remove {title}',
  'study.day': 'Day',
  'study.blockTitle': 'What will you study',
  'study.minutesLabel': 'Min',
  'study.forGoal': 'Goal',
  'study.addBlock': 'Add',
  'study.share': 'Share my progress with my guardians',
  'study.privacy': 'Your plan is yours; teachers do not see it. If you share it, guardians see only weekly totals and goal percentages, not block titles.',
  'study.notShared': 'The study plan is not shared (sharing is your child’s choice).',
  'tutor.title': 'AI tutor',
  'tutor.intro': 'Gives hints, asks questions and explains ideas so you understand the topic. It does not do your homework for you.',
  'tutor.consent.hints': 'It does not hand over answers; it guides you with hints and questions. It can be wrong; check important things with your teacher.',
  'tutor.consent.redaction': 'What you write is sent to an AI service; personal data such as phone numbers, e-mail or ID numbers is hidden before it leaves.',
  'tutor.consent.retention': 'Conversations are kept for 30 days and then deleted; you can delete them yourself any time.',
  'tutor.consent.visibility': 'Only you see your conversations. Your teacher and guardian only see how many messages were sent.',
  'tutor.consent.guardian': 'Because you are under 18, your guardian also needs to approve.',
  'tutor.consent.accept': 'I understand, I want to use it',
  'tutor.consent.withdraw': 'Withdraw my AI tutor consent',
  'tutor.reason.account': 'Your account cannot use the AI tutor right now (e-mail verification or guardian-approved registration needed).',
  'tutor.reason.guardian_approval_required': 'Waiting for your guardian to approve the AI tutor. They can approve it on their Learn page.',
  'tutor.reason.quiz_in_progress': 'You have a quiz in progress in this class; the AI tutor is off until it is done.',
  'tutor.reason.quota': 'You have used today’s AI tutor messages; try again tomorrow.',
  'tutor.newSession': 'Start a new conversation',
  'tutor.remaining': { one: '{count} message left today.', other: '{count} messages left today.' },
  'tutor.safety': 'Important',
  'tutor.thinking': 'The AI tutor is thinking…',
  'tutor.redacted': { one: '{count} piece of personal data was hidden before sending.', other: '{count} pieces of personal data were hidden before sending.' },
  'tutor.ask': 'What don’t you understand? What did you try?',
  'tutor.turnsLeft': { one: '{count} message left in this conversation', other: '{count} messages left in this conversation' },
  'tutor.send': 'Send',
  'tutor.teacher.enable': 'Turn on the AI tutor in this class',
  'tutor.teacher.note': 'Students get hints and explanations, not ready answers; it is off during quizzes. Under-18s also need a guardian’s approval. You cannot read conversations, only usage counts.',
  'tutor.teacher.usage': 'This week: {students} students, {messages} messages',
  'tutor.guardian.approve': 'I allow my child to use the AI tutor',
  'tutor.guardian.note': 'Usable once the teacher turned it on in class and your child agreed. It gives hints, not homework answers; personal data is hidden; conversations are deleted after 30 days. You cannot read them, only see a weekly message count.',
  'tutor.guardian.usage': { one: '{count} message this week', other: '{count} messages this week' },
  'admin.tab.system': 'System health',
  'admin.tab.config': 'Settings',
  'admin.tab.audit': 'Audit log',
  'admin.tab.security': 'Security events',
  'admin.tab.ai': 'AI usage',
  'adminOps.reasonPrompt': 'Reason for this change (written to the audit log):',
  'adminOps.reasonShort': 'Please give a reason of at least 5 characters.',
  'adminOps.config.note': 'Changes take effect immediately and are written to the audit log with their reason. Only super admins can change them.',
  'adminOps.settings': 'General settings',
  'adminOps.registrationMode': 'Registration mode',
  'adminOps.registration.open': 'Open (anyone can sign up)',
  'adminOps.registration.invite': 'Invite only (code required)',
  'adminOps.registration.closed': 'Closed',
  'adminOps.source.console': 'set in the console',
  'adminOps.source.env': 'server default (.env)',
  'adminOps.range': 'range {min}–{max} · default {def}',
  'adminOps.save': 'Save',
  'adminOps.flags': 'Feature flags',
  'adminOps.flagsNote': 'Turning a feature off turns it off for everyone. The child-safety floor is not a flag; no flag can loosen it.',
  'adminOps.overrides': { one: '{count} override', other: '{count} overrides' },
  'adminOps.plan': 'Plan limits',
  'adminOps.secretsTitle': 'Why secrets are not here',
  'adminOps.secretsNote': 'The database password, SMTP, the Web Push private key, the TURN secret, the AI API key and backup credentials live only in root-only /etc/dijitalapp/*.env files on the server. Managed from the console, a single compromised admin session could leak every secret or redirect backups elsewhere.',
  'adminOps.search': 'Search',
  'adminOps.more': 'Older entries',
  'adminOps.empty': 'Nothing here.',
  'adminOps.refresh': 'Refresh',
  'adminOps.mail.test': 'Send a test email',
  'adminOps.mail.accepted': '{relay} accepted it → {to}. Check your inbox and spam folder.',
  'adminOps.mail.localRelay': 'The local relay on this server ({relay}) accepted it, but delivery cannot be confirmed (outbound mail ports are blocked here). SMTP_URL should point to an external provider such as Resend.',
  'adminOps.mail.failed': 'Could not send ({error}). Check the SMTP setting on the server.',
  'adminOps.audit.action': 'Action (prefix)',
  'adminOps.audit.actor': 'Who (username)',
  'adminOps.audit.resourceType': 'Resource type',
  'adminOps.audit.before': 'Before',
  'adminOps.audit.after': 'After',
  'adminOps.security.summary': 'Last 7 days',
  'adminOps.security.counts': '24 h: {d1} · 7 d: {d7}',
  'adminOps.ai.period': 'Period',
  'adminOps.ai.days': { one: '{count} day', other: '{count} days' },
  'adminOps.ai.provider': 'Provider',
  'adminOps.ai.off': 'Off (no ANTHROPIC_API_KEY)',
  'adminOps.ai.safety': 'AI tutor safety replies: {count} (no content stored)',
  'adminOps.ai.line': '{requests} requests · {ok} ok · {refused} refused · {errors} errors · {users} people · {tokens} tokens · avg {latency} ms',
  'adminOps.ai.daily': 'Requests per day',
  'adminOps.ai.topUsers': 'Top users',
  'adminOps.ai.privacy': 'Only counts are kept; no AI request text is ever stored.',
  'adminOps.state.ok': 'working',
  'adminOps.state.degraded': 'degraded',
  'adminOps.state.fail': 'failing',
  'adminOps.state.off': 'off',
  'adminOps.system.release': 'Release: {release} · Node {node}',
  'adminOps.system.process': 'Uptime: {uptime} min · memory {memory} MB',
  'adminOps.system.migrations': 'Migrations: {count} · latest: {latest}',
  'adminOps.system.outbox': 'Pending events: {pending} · oldest {oldest} s',
  'adminOps.system.db': 'Database size: {size} MB',
  'adminOps.system.counts': 'Users: {users} · new in 24 h: {newUsers} · messages: {messages} · live connections on this server: {sockets}',
  'adminOps.system.note': 'Backups and external monitoring run as timers on the server; their status is not shown in the console yet.',
  'settings.section.account': 'Account',
  'settings.section.account.desc': 'Your profile and session',
  'settings.section.appearance': 'Appearance',
  'settings.section.appearance.desc': 'Theme and language',
  'settings.section.privacy': 'Privacy',
  'settings.section.privacy.desc': 'Who can see and message you',
  'settings.section.notifications': 'Notifications',
  'settings.section.notifications.desc': 'Push notifications and previews',
  'settings.section.security': 'Security',
  'settings.section.security.desc': 'Passkeys and end-to-end encryption',
  'settings.section.devices': 'Devices',
  'settings.section.devices.desc': 'Devices signed in to your account',
  'settings.theme': 'Theme',
  'settings.account.details': 'Account details',
  'settings.account.email': 'Email',
  'settings.account.verified': 'Verified',
  'settings.account.unverified': 'Not verified',
  'settings.account.type': 'Account type',
  'settings.account.adult': 'Adult',
  'settings.account.minor': 'Under 18 (protected)',
  'settings.account.since': 'Member since',
  'settings.account.session': 'Session',
  'settings.account.sessionHint': 'Signs this device out. Manage your other devices under Devices.',
  'e2ee.deviceUnverifiedShort': 'needed for encrypted chats',
  'e2ee.fix': 'Fix',
  'e2ee.later': 'Later',
  'e2ee.openSecurity': 'Security settings',
  'e2ee.singleDeviceHint': 'No other device and no saved recovery key? Settings → Security → "Reset encryption identity". If you have no encrypted chats yet, nothing is lost.',
  'chat.splashTitle': '{brand} Web',
  'chat.splashFoot': 'Messages travel over an encrypted connection; you can turn on end-to-end encryption per chat.',
  'chat.newDesc': 'Add someone by username or create a new group.',
  'e2ee.fix.otherTitle': 'Approve from your other device',
  'e2ee.fix.otherBody': 'On your other device where DijitalApp is open, accept the request and confirm that the emojis on both screens match.',
  'e2ee.fix.waiting': 'Waiting for your other device…',
  'e2ee.fix.resetTitle': 'Set up encryption again on this device',
  'e2ee.fix.resetBody': 'No other device is signed in to your account. Just enter your password: this device becomes verified and you get a new recovery key (save it). Earlier encrypted messages stay readable only with the old recovery key.',
  'e2ee.fix.resetAction': 'Set up again',
  'e2ee.fix.recoveryTitle': 'Verify with your recovery key',
  'e2ee.fix.haveRecovery': 'I have a recovery key',
  'e2ee.fix.noAccess': 'I can\'t reach my other device',
  'e2ee.fix.resetBodyOther': 'If you can\'t reach your other device, just enter your password: this device becomes verified and you get a new recovery key (save it). Earlier encrypted messages stay readable only with the old recovery key.',
};
